const safetyPictures = [
    "s08", "u11", "u16", "s01", "u03", "u14", "u04", "s06", "u10", "u18", "u12", "s10", "s12", "u13", "s16", "s17", "s15", "u02", "s05", "u17", "s04", "s18", "u08", "s03", "u01", "s11", "s14", "u07", "u06", "u09", "u15", "s07", "s09", "u05", "s02", "s13"
];

const shortTermMemoryDigits = [
    "418494685", "824742559", "673127185", "346775874", "937161689"
];

export const abstractReasoningAnswers = [
    1, 6, 6, 5, 4, 2, 5, 3, 4, 1, 2, 4, 5, 6, 5, 3, 1, 6, 1, 2, 4, 2, 5, 4, 3
];

/* NOTE: constants must match StepConstants.cs  */

export const nullOption = 999;
export const skipRemaining = 998;

export const badRequest = -1;
export const tryLater = -2;
export const done = -3;

export const pagesPerTest = 1000;

export const startPage = 1;
export const welcomePage = 2;
export const consentPage = 3;
export const lastTestFinishedPage = 4;
export const assessmentFinishedPage = 5;
export const commentsPage = 6;
export const remoteComplete = 7;

export const safetyTestIntro = 1001;
export const safetyTestInstructions = 1002;
export const safetyTestFirstPage = 1003;
export const safetyTestPages = 36;
export const safetyTestLastPage = safetyTestFirstPage + safetyTestPages - 1;
export const safetyTestCompletedPage = safetyTestLastPage + 1;

export const inspectionTimeTestIntro = 2001;
export const inspectionTimeTestInstructions = 2002;
export const inspectionTimeTestFirstPage = 2003;
export const inspectionTimeTestPages = 6;
export const inspectionTimeTestLastPage = inspectionTimeTestFirstPage + inspectionTimeTestPages - 1;
export const inspectionTimeTestCompletedPage = inspectionTimeTestLastPage + 1;

export const shortTermMemoryTestIntro = 3001;
export const shortTermMemoryTestInstructions = 3002;
export const shortTermMemoryTestFirstPage = 3003;
export const shortTermMemoryTestPages = 5;
export const shortTermMemoryTestLastPage = shortTermMemoryTestFirstPage + shortTermMemoryTestPages - 1;
export const shortTermMemoryTestCompletedPage = shortTermMemoryTestLastPage + 1;

export const sustainedAttentionTestIntro = 4001;
export const sustainedAttentionTestInstructions = 4002;
export const sustainedAttentionTestPage = 4003;
export const sustainedAttentionTestCompletedPage = 4004;

export const literacyTestIntro = 5001;
export const literacyTestInstructions = 5002;
export const literacyTestFirstPage = 5003;
export const literacyTestPages = 20;
export const literacyTestLastPage = literacyTestFirstPage + literacyTestPages - 1;
export const literacyTestCompletedPage = literacyTestLastPage + 1;

export const numeracyTestIntro = 6001;
export const numeracyTestInstructions = 6002;
export const numeracyTestFirstPage = 6003;
export const numeracyTestPages = 12;
export const numeracyTestLastPage = numeracyTestFirstPage + numeracyTestPages - 1;
export const numeracyTestCompletedPage = numeracyTestLastPage + 1;

export const abstractReasoningTestIntro = 7001;
export const abstractReasoningTestInstructions = 7002;
export const abstractReasoningTestFirstPage = 7003;
export const abstractReasoningTestPages = 25;
export const abstractReasoningTestLastPage = abstractReasoningTestFirstPage + abstractReasoningTestPages - 1;
export const abstractReasoningTestCompletedPage = abstractReasoningTestLastPage + 1;

export const mechanicalReasoningTestIntro = 8001;
export const mechanicalReasoningTestInstructions = 8002;
export const mechanicalReasoningTestFirstPage = 8003;
export const mechanicalReasoningTestPages = 20;
export const mechanicalReasoningTestLastPage = mechanicalReasoningTestFirstPage + mechanicalReasoningTestPages - 1;
export const mechanicalReasoningTestCompletedPage = mechanicalReasoningTestLastPage + 1;

export const numericalReasoningTestIntro = 9001;
export const numericalReasoningTestInstructions = 9002;
export const numericalReasoningTestFirstPage = 9003;
export const numericalReasoningTestPages = 30;
export const numericalReasoningTestLastPage = numericalReasoningTestFirstPage + numericalReasoningTestPages - 1;
export const numericalReasoningTestCompletedPage = numericalReasoningTestLastPage + 1;

export const verbalReasoningTestIntro = 10001;
export const verbalReasoningTestInstructions = 10002;
export const verbalReasoningTestFirstPage = 10003;
export const verbalReasoningTestPages = 30;
export const verbalReasoningTestLastPage = verbalReasoningTestFirstPage + verbalReasoningTestPages - 1;
export const verbalReasoningTestCompletedPage = verbalReasoningTestLastPage + 1;

export const workProfileQuestionnaireTestIntro = 11001;
export const workProfileQuestionnaireTestInstructions = 11002;
export const workProfileQuestionnaireTestFirstPage = 11003;
export const workProfileQuestionnaireTestPages = 83;
export const workProfileQuestionnaireTestLastPage = workProfileQuestionnaireTestFirstPage + workProfileQuestionnaireTestPages - 1;
export const workProfileQuestionnaireTestCompletedPage = workProfileQuestionnaireTestLastPage + 1;

export const personalFactorsInventoryTestIntro = 12001;
export const personalFactorsInventoryTestInstructions = 12002;
export const personalFactorsInventoryTestFirstPage = 12003;
export const personalFactorsInventoryTestPages = 163;
export const personalFactorsInventoryTestLastPage = personalFactorsInventoryTestFirstPage + personalFactorsInventoryTestPages - 1;
export const personalFactorsInventoryTestCompletedPage = personalFactorsInventoryTestLastPage + 1;

export function getJumpToMenuItems(tests) {
    const arr = [];

    arr.push({ id: welcomePage, name: "Welcome" });
    arr.push({ id: 0, name: "-" });

    if ((tests && 1) > 0) {
        arr.push({ id: safetyTestIntro, name: "Safety" });
    }

    if ((tests && 2) > 0) {
        arr.push({ id: inspectionTimeTestIntro, name: "Inspection Time" });
    }

    if ((tests && 4) > 0) {
        arr.push({ id: shortTermMemoryTestIntro, name: "Short Term Memory" });
    }

    if ((tests && 8) > 0) {
        arr.push({ id: sustainedAttentionTestIntro, name: "Sustained Attention" });
    }

    if ((tests && 16) > 0) {
        arr.push({ id: literacyTestIntro, name: "Literacy" });
    }

    if ((tests && 32) > 0) {
        arr.push({ id: numeracyTestIntro, name: "Numeracy" });
    }

    if ((tests && 64) > 0) {
        arr.push({ id: abstractReasoningTestIntro, name: "Abstract Reasoning" });
    }

    if ((tests && 128) > 0) {
        arr.push({ id: mechanicalReasoningTestIntro, name: "Mechanical Reasoning" });
    }

    if ((tests && 256) > 0) {
        arr.push({ id: numericalReasoningTestIntro, name: "Numerical Reasoning" });
    }

    if ((tests && 512) > 0) {
        arr.push({ id: verbalReasoningTestIntro, name: "Verbal Reasoning" });
    }

    if ((tests && 1024) > 0) {
        arr.push({ id: workProfileQuestionnaireTestIntro, name: "Work Profile Questionnaire" });
    }

    if ((tests && 2048) > 0) {
        arr.push({ id: personalFactorsInventoryTestIntro, name: "Personal Factors Inventory" });
    }

    arr.push({ id: 0, name: "-" });
    arr.push({ id: lastTestFinishedPage, name: "Last Test Finished" });

    return arr;
}

export function getPageTitle(step) {
    switch (step) {
        case startPage: return "Start";
        case consentPage: return "Consent";
        case welcomePage: return "Welcome";
        case lastTestFinishedPage: return "Last Test Finished";
        case assessmentFinishedPage: return "Assessment Finished";
        case commentsPage: return "Comments";
        case remoteComplete: return "Assessment Complete";
        default:
            break;
    }

    if (step >= safetyTestIntro && step <= safetyTestCompletedPage) {
        return "Safety";
    }
    else if (step >= inspectionTimeTestIntro && step <= inspectionTimeTestCompletedPage) {
        return "Inspection Time";
    }
    else if (step >= shortTermMemoryTestIntro && step <= shortTermMemoryTestCompletedPage) {
        return "Short Term Memory";
    }
    else if (step >= sustainedAttentionTestIntro && step <= sustainedAttentionTestCompletedPage) {
        return "Sustained Attention";
    }
    else if (step >= literacyTestIntro && step <= literacyTestCompletedPage) {
        return "Literacy";
    }
    else if (step >= numeracyTestIntro && step <= numeracyTestCompletedPage) {
        return "Numeracy";
    }
    else if (step >= abstractReasoningTestIntro && step <= abstractReasoningTestCompletedPage) {
        return "Abstract Reasoning";
    }
    else if (step >= mechanicalReasoningTestIntro && step <= mechanicalReasoningTestCompletedPage) {
        return "Mechanical Reasoning";
    }
    else if (step >= numericalReasoningTestIntro && step <= numericalReasoningTestCompletedPage) {
        return "Numerical Reasoning";
    }
    else if (step >= verbalReasoningTestIntro && step <= verbalReasoningTestCompletedPage) {
        return "Verbal Reasoning";
    }
    else if (step >= workProfileQuestionnaireTestIntro && step <= workProfileQuestionnaireTestCompletedPage) {
        return "Work Profile Questionnaire";
    }
    else if (step >= personalFactorsInventoryTestIntro && step <= personalFactorsInventoryTestCompletedPage) {
        return "Personal Factors Inventory";
    }

    return null;
}

export function getContent(step) {
    switch (step) {
        case welcomePage: return getWelcome();
        case consentPage: return getConsent();
        case lastTestFinishedPage: return { buttonsType: "finish" };
        case assessmentFinishedPage: return { buttonsType: "next" };
        case commentsPage: return { buttonsType: "next", disableNext: true };
        case remoteComplete: return { buttonsType: "close" };
        case safetyTestIntro: return getSafetyIntro();
        case safetyTestInstructions: return getSafetyInstructions();
        case safetyTestCompletedPage: return { buttonsType: "next", testName: "Safety" };
        case inspectionTimeTestIntro: return getInspectionTimeIntro();
        case inspectionTimeTestInstructions: return getInspectionTimeInstructions();
        case inspectionTimeTestCompletedPage: return { buttonsType: "next", testName: "Inspection Time" };
        case shortTermMemoryTestIntro: return getShortTermMemoryIntro();
        case shortTermMemoryTestInstructions: return getShortTermMemoryInstructions();
        case shortTermMemoryTestCompletedPage: return { buttonsType: "next", testName: "Short Term Memory" };
        case sustainedAttentionTestIntro: return getSustainedAttentionIntro();
        case sustainedAttentionTestInstructions: return getSustainedAttentionInstructions();
        case sustainedAttentionTestCompletedPage: return { buttonsType: "next", testName: "Sustained Attention" };
        case literacyTestIntro: return getLiteracyIntro();
        case literacyTestInstructions: return getLiteracyInstructions();
        case literacyTestCompletedPage: return { buttonsType: "next", testName: "Literacy" };
        case numeracyTestIntro: return getNumeracyIntro();
        case numeracyTestInstructions: return getNumeracyInstructions();
        case numeracyTestCompletedPage: return { buttonsType: "next", testName: "Numeracy" };
        case abstractReasoningTestIntro: return getAbstractReasoningIntro();
        case abstractReasoningTestInstructions: return getAbstractReasoningInstructions();
        case abstractReasoningTestCompletedPage: return { buttonsType: "next", testName: "Abstract Reasoning" };
        case mechanicalReasoningTestIntro: return getMechanicalReasoningIntro();
        case mechanicalReasoningTestInstructions: return getMechanicalReasoningInstructions();
        case mechanicalReasoningTestCompletedPage: return { buttonsType: "next", testName: "Mechanical Reasoning" };
        case numericalReasoningTestIntro: return getNumericalReasoningIntro();
        case numericalReasoningTestInstructions: return getNumericalReasoningInstructions();
        case numericalReasoningTestCompletedPage: return { buttonsType: "next", testName: "Numerical Reasoning" };
        case verbalReasoningTestIntro: return getVerbalReasoningIntro();
        case verbalReasoningTestInstructions: return getVerbalReasoningInstructions();
        case verbalReasoningTestCompletedPage: return { buttonsType: "next", testName: "Verbal Reasoning" };
        case workProfileQuestionnaireTestIntro: return getWorkProfileQuestionnaireIntro();
        case workProfileQuestionnaireTestInstructions: return getWorkProfileQuestionnaireInstructions();
        case workProfileQuestionnaireTestCompletedPage: return { buttonsType: "next", testName: "Work Profile Questionnaire" };
        case personalFactorsInventoryTestIntro: return getPersonalFactorsInventoryIntro();
        case personalFactorsInventoryTestInstructions: return getPersonalFactorsInventoryInstructions();
        case personalFactorsInventoryTestCompletedPage: return { buttonsType: "next", testName: "Personal Factors Inventory" };
        default:
            break;
    }

    if (step >= safetyTestFirstPage && step <= safetyTestLastPage) {
        const index = step - safetyTestFirstPage;
        return {
            buttonsType: "safety",
            img: safetyPictures[index] + ".jpg",
            index: index
        };
    }
    else if (step >= inspectionTimeTestFirstPage && step <= inspectionTimeTestLastPage) {
        const index = step - inspectionTimeTestFirstPage;
        return {
            disableNext: true,
            index: index
        };
    }
    else if (step >= shortTermMemoryTestFirstPage && step <= shortTermMemoryTestLastPage) {
        const index = step - shortTermMemoryTestFirstPage;
        return {
            disableNext: true,
            index: index,
            digits: shortTermMemoryDigits[index]
        };
    }
    else if (step === sustainedAttentionTestPage) {
        return {
            disableNext: true
        };
    }
    else if (step >= literacyTestFirstPage && step <= literacyTestLastPage) {
        const index = step - literacyTestFirstPage;

        const data = getLiteracyContent(index);

        data.index = index;
        data.disableNext = true;

        return data;
    }
    else if (step >= numeracyTestFirstPage && step <= numeracyTestLastPage) {
        const index = step - numeracyTestFirstPage;

        const data = getNumeracyContent(index);

        data.index = index;
        data.disableNext = true;

        return data;
    }
    else if (step >= abstractReasoningTestFirstPage && step <= abstractReasoningTestLastPage) {
        const index = step - abstractReasoningTestFirstPage;
        return {
            buttonsType: step < abstractReasoningTestLastPage ? "bn" : "be",
            index: index
        };
    }
    else if (step >= mechanicalReasoningTestFirstPage && step <= mechanicalReasoningTestLastPage) {
        const index = step - mechanicalReasoningTestFirstPage;

        const data = getMechanicalReasoningContent(index);

        data.buttonsType = step < mechanicalReasoningTestLastPage ? "bn" : "be";
        /* data.buttonsType = "bne"; */
        data.index = index;

        return data;
    }
    else if (step >= numericalReasoningTestFirstPage && step <= numericalReasoningTestLastPage) {
        const index = step - numericalReasoningTestFirstPage;

        const data = getNumericalReasoningContent(index);

        data.buttonsType = step < numericalReasoningTestLastPage ? "bn" : "be";
        /* data.buttonsType = "bne"; */
        data.index = index;

        return data;
    }
    else if (step >= verbalReasoningTestFirstPage && step <= verbalReasoningTestLastPage) {
        const index = step - verbalReasoningTestFirstPage;

        const data = getVerbalReasoningContent(index);

        data.buttonsType = step < verbalReasoningTestLastPage ? "bn" : "be";
        /* data.buttonsType = "bne"; */
        data.index = index;

        return data;
    }
    else if (step >= workProfileQuestionnaireTestFirstPage && step <= workProfileQuestionnaireTestLastPage) {
        const index = step - workProfileQuestionnaireTestFirstPage;

        const question = getWorkProfileQuestionnaireContent(index);

        return {
            index: index,
            disableNext: true,
            question: question
        };
    }
    else if (step >= personalFactorsInventoryTestFirstPage && step <= personalFactorsInventoryTestLastPage) {
        const index = step - personalFactorsInventoryTestFirstPage;

        const question = getPersonalFactorsInventoryContent(index);

        return {
            index: index,
            disableNext: true,
            question: question
        };
    }

    return null;
}

export function secondsToTime(secondsRemaining) {
    let minutes = Math.floor(secondsRemaining / 60).toString();
    let seconds = (secondsRemaining % 60).toString();

    if (minutes.length === 1) {
        minutes = `0${minutes}`;
    }

    if (seconds.length === 1) {
        seconds = `0${seconds}`;
    }

    return minutes + ":" + seconds;
}

function getWelcome() {
    return {
        elems: [
            {
                type: "t",
                elems: [
                    {
                        type: "-",
                        tabId: 1,
                        elems: [
                            { type: "h1", text: "Welcome" },
                            { type: "p", text: "Today you will take a series of tests to measure various aspects of your abilities and attitudes." },
                            { type: "p", text: "It is important for you to be calm and thoughtful so that you can deliver your best effort." }]
                    },
                    {
                        type: "-",
                        tabId: 2,
                        elems: [
                            { type: "p", text: "Each test is preceded by instructions and practice. The practice will help you prepare for the actual test." }]
                    },
                    {
                        type: "-",
                        tabId: 3,
                        elems: [
                            { type: "p", text: "Instructions will be both spoken and written. You cannot commence the practice before the instructions are finished." },
                            { type: "p", text: "Listen carefully to all instructions so you can use this program effectively." }]
                    },
                    {
                        type: "-",
                        tabId: 4,
                        elems: [
                            { type: "p", text: "Controls to REPLAY speech and adjust the volume can be found at the top right hand corner of the page." },
                            { type: "p", text: "When all the instructions have been presented, you can click the REPLAY button to hear the instructions again. You can only replay the instructions once." }]
                    },
                    {
                        type: "-",
                        tabId: 5,
                        elems: [
                            { type: "p", text: "Once you have read the instructions you may undertake the practice. When you are done, you may then proceed to the test." }]
                    },
                    {
                        type: "-",
                        tabId: 6,
                        elems: [
                            { type: "p", text: "If you need to take a break, please do so between tests." }]
                    }]
            }]
    };
}

function getConsent() {
    return {
        buttonsType: "consent",
        elems: [
            { type: "h1", text: "Informed Consent Statement" },
            { type: "h2", text: "Before you start, please read and listen carefully to the Consent Statement and when you are ready, click on the I CONSENT button below." },
            { type: "h2", text: "If you feel you cannot give your consent, please speak with your administrator." },
            {
                type: "g", elems: [
                    { type: "p", text: "The assessment you are about to undertake is designed for either recruitment or professional development purposes. The measures conform to the standard requirements of psychological assessments and provide an objective and fair method of measurement." },
                    { type: "p", text: "A report will be written by a psychologist and will be provided to the company who has commissioned this assessment. The report remains the property of this company and is stored for a limited period as specified by company policy." },
                    { type: "p", text: "It is important for you to be aware that your administrator does not have immediate access to your results and may not be trained in the interpretation of these tests." },
                    { type: "p", text: "Only psychologists trained in the use of the CPP can provide informed interpretation of results. If you wish to obtain feedback on your results you should contact the psychologist who is contracted by the company." },
                    { type: "p", text: "The company is obligated to maintain strict security and confidentiality with all information arising from the results of this assessment." },
                    { type: "p", text: "Finally, the results from such assessments do not provide the sole basis for decisions, but are used in conjunction with other information in assisting with decisions about your employment or professional development." },
                    { type: "p", text: "If you have any questions or concerns about the completion of this assessment or the handling of the results, please discuss these with your administrator." }]
            }]
    };
}

export function getStandardPracticeCompletedText() {
    // for Safety, Short Term Memory and Sustained Attention
    return ["OK, now you are ready to start the real test.", "Click on the NEXT button to proceed."];
}

export function getInspectionTimePracticeCompletedText() {
    // for Inspection Time
    return ["OK, now you are ready to start the real test.", "Please note: Be prepared for this test to start quickly.", "Click on the NEXT button when you are ready."];
}

function getSafetyIntro() {
    return {
        elems: [
            { type: "h1", text: "Safety", icon: "far fa-exclamation-triangle" },
            { type: "h2", text: "Safe or unsafe?" },
            {
                type: "g", elems: [
                    { type: "p", text: "This test assesses your ability to make good judgements about the safety of workplace situations. You will see a series of workplace pictures, one after the other." },
                    { type: "p", text: "Half of the pictures show a safe situation, the other half show an unsafe one. Your task is to judge whether each situation is safe or unsafe, given only the information in each picture." },
                    { type: "p", text: "There is no time limit for this test." }]
            }]
    };
}

function getSafetyInstructions() {
    return {
        disableNext: true,
        elems: [
            { type: "p", text: "Look at the practice image below." },
            { type: "p", text: "If you think that the picture shows a safe situation, click the SAFE button." },
            { type: "p", text: "If you think that the picture shows an unsafe situation, click the UNSAFE button." },
            { type: "p", text: "You will be able to proceed once you have made your choice." }]
    };
}

function getInspectionTimeIntro() {
    return {
        elems: [
            { type: "h1", text: "Inspection Time", icon: "far fa-stopwatch" },
            { type: "h2", text: "Which line is longer?" },
            {
                type: "g", elems: [
                    { type: "p", text: "This test measures how much time you need to make an accurate judgement." },
                    { type: "p", text: "You will view long and short lines like these below, and each time you'll need to identify which line is longer." }]
            },
            { type: "img", src: "inspection-time.png", width: "100px", height: "36px" }]
    };
}

function getInspectionTimeInstructions() {
    return {
        disableNext: true,
        elems: [
            {
                type: "t",
                elems: [
                    {
                        type: "-",
                        tabId: 1,
                        elems: [
                            { type: "p", text: "If the top line is longer then you should click on the TOP LINE LONGER button." },
                            { type: "p", text: "If the bottom line is longer then you should click on the BOTTOM LINE LONGER button." }]
                    },
                    {
                        type: "-",
                        tabId: 2,
                        elems: [
                            { type: "p", text: "Please note: For all attempts beyond your first attempt, hashtags will quickly cover the lines." },
                            { type: "p", text: "The time for which the lines are visible will keep decreasing to the point where you can no longer tell which one is longer." }]
                    },
                    {
                        type: "-",
                        tabId: 3,
                        elems: [
                            { type: "p", text: "It is critical that you look at the red cross for this test. When you are ready, click on the TRY button below to start the practice." }]
                    }]
            }]
    };
}

function getShortTermMemoryIntro() {
    return {
        elems: [
            { type: "h1", text: "Short Term Memory", icon: "far fa-mind-share" },
            { type: "h2", text: "How many numbers can you remember?" },
            {
                type: "g", elems: [
                    { type: "p", text: "In this test, you will be presented with lists of nine numbers which you must keep in memory for a few seconds, then enter them using the number pad in the exact order." }]
            }]
    };
}

function getShortTermMemoryInstructions() {
    return {
        disableNext: true,
        elems: [
            {
                type: "t",
                elems: [
                    {
                        type: "-",
                        tabId: 1,
                        elems: [
                            { type: "p", text: "The nine numbers will be presented one after another, in the nine spaces below. Try to remember as many as you can." }]
                    },
                    {
                        type: "-",
                        tabId: 2,
                        elems: [
                            { type: "p", text: "When the last number has been shown, use the number-pad to enter the numbers in the same order as they appeared. Do not use any method other than your own memory to complete this task." }]
                    },
                    {
                        type: "-",
                        tabId: 3,
                        elems: [
                            { type: "p", text: "If you can't remember the number shown in a given position, enter a question-mark (?) from the number-pad." }]
                    },
                    {
                        type: "-",
                        tabId: 4,
                        elems: [
                            { type: "p", text: "You can change the numbers by re-selecting the number you want to change." }]
                    },
                    {
                        type: "-",
                        tabId: 5,
                        elems: [
                            { type: "p", text: "Please note: Once you click on the NEXT button, your answer will be locked in and you won't be able to review or make changes." }]
                    },
                    {
                        type: "-",
                        tabId: 6,
                        elems: [
                            { type: "p", text: "When you are ready, click on the TRY button below to start the practice." }]
                    }]
            }]
    };
}

function getSustainedAttentionIntro() {
    return {
        elems: [
            { type: "h1", text: "Sustained Attention", icon: "far fa-clock" },
            { type: "h2", text: "Find the same pair" },
            {
                type: "g", elems: [
                    { type: "p", text: "This test measures your ability to stay focused on a simple repetitive task." }]
            }]
    };
}

function getSustainedAttentionInstructions() {
    return {
        disableNext: true,
        elems: [
            {
                type: "t",
                elems: [
                    {
                        type: "-",
                        tabId: 1,
                        elems: [
                            { type: "p", text: "You will see pairs of patterns, like these in the two boxes below. The patterns will change every second." }]
                    },
                    {
                        type: "-",
                        tabId: 2,
                        elems: [
                            { type: "p", text: "When the two patterns are exactly the same, click the SAME button quickly before they change." }]
                    },
                    {
                        type: "-",
                        tabId: 3,
                        elems: [
                            { type: "p", text: "Clicking the SAME button while an identical pair is shown will score a HIT." },
                            { type: "p", text: "You will score a MISS if you click the SAME button when the pair of patterns are NOT the same - or if you fail to click the SAME button when an identical pair is shown." }]
                    },
                    {
                        type: "-",
                        tabId: 4,
                        elems: [
                            { type: "p", text: "Click the TRY button to start 30 seconds of practice." }]
                    }]
            }]
    };
}

function getLiteracyIntro() {
    return {
        elems: [
            { type: "h1", text: "LITERACY", icon: "far fa-book" },
            {
                type: "g", elems: [
                    { type: "p", text: "This test measures your ability to read and understand written material." }]
            }]
    };
}

function getLiteracyInstructions() {
    return {
        disableNext: true,
        elems: [
            {
                type: "t",
                elems: [
                    {
                        type: "-",
                        tabId: 1,
                        elems: [
                            { type: "p", text: "First, you will read a passage from a workplace procedure, like this one." },
                            { type: "p", text: "Read the material carefully. If there is a scroll bar on the right side, use it to read the entire passage." }]
                    },
                    {
                        type: "-",
                        tabId: 2,
                        elems: [
                            { type: "p", text: "When you have read the passage, you will read a question about the procedures in the passage." },
                            { type: "p", text: "Each question applies to the content of the passage above." }]
                    },
                    {
                        type: "-",
                        tabId: 3,
                        elems: [
                            { type: "p", text: "Finally, you will select which of these four answers you think is correct." }]
                    },
                    {
                        type: "-",
                        tabId: 4,
                        elems: [
                            { type: "p", text: "You can change your answer as often as you like until you lock it in by clicking on the NEXT button." }]
                    },
                    {
                        type: "-",
                        tabId: 5,
                        elems: [
                            { type: "p", text: "Please note: Once you click on the NEXT button, your answer will be locked in and you won't be able to review it anymore." }]
                    },
                    {
                        type: "-",
                        tabId: 6,
                        elems: [
                            { type: "p", text: "When you are ready, read the following passage and pick one of the four possible answers for the practice question, then click on the NEXT button to start the test." }]
                    }]
            }],
        passage: [
            { type: "p", text: "Mining personnel who work on a continuous shift roster (day and night shifts) are at risk from fatigue.  It is recommended that all mining employees on continuous shift work reside in the camp accommodation as all facilities to help avoid fatigue are available. You can avoid fatigue by having sufficient sleep, eating a well balanced diet and exercising regularly. It is recommended that you have 8 hours of sleep between each shift. If you fail to have 8 hours of sleep you must notify your supervisor who will decide on the appropriate measure to take." },
            { type: "p", text: "If you feel tired during work and while carrying out work duties you must notify your supervisor immediately.  You must also leave your work area/machine and take a short break from your duties in the crib hut. It is the responsibility of each employee to arrive for work in a fit and alert state." }],
        question: "Falling asleep while carrying out work tasks can result from:",
        options: [
            { text: "Having a good diet." },
            { text: "Having too many short breaks." },
            { text: "Not having enough sleep." },
            { text: "Spending too much time at the camp." }]
    };
}

function getLiteracyContent(index) {
    switch (index) {
        case 0:
            return {
                passage: [
                    { type: "p", text: "Where a manual handling task has been assessed as an unacceptable risk, the following controls shall be considered:" },
                    { type: "p", text: "  * Redesign the manual handling task to eliminate or control the risk factors, and" },
                    { type: "p", text: "  * Ensure that mine workers involved in manual handling receive appropriate training." },
                    { type: "p", text: "Where redesign is not practicable, the employer shall:" },
                    { type: "p", text: "  * Provide mechanical aids and/or PPE, and/or arrange for team lifting in order to reduce the risk, and/or" },
                    { type: "p", text: "  * Ensure that mine workers receive appropriate training in methods of manual handling appropriate for that manual  handling task and/or in the correct use of the mechanical aids and/or PPE and/or team lifting procedures." },
                    { type: "p", text: "Mechanical handling equipment should be used if loads cannot be dealt with safely using manual handling techniques. Such equipment includes cranes, hoists, forklifts, jacks etc. There may be hazards associated with using plant such as this and persons are required to be competent and authorised to do so. The implementation of this risk control approach, as with any successful systematic process, does not end with the implementation of some change. The effectiveness of the new controls needs to be reviewed regularly to ensure that the objectives are being achieved and there are no unforeseen negative outcomes." }],
                question: "What should happen if a manual handling task is judged to involve an unacceptable risk?",
                answer: 3,
                options: [
                    { text: "People need to be very careful when lifting heavy weights." },
                    { text: "Ensure only fit people are asked to lift heavy weights." },
                    { text: "Think of doing the task in different ways to get rid of the risk." },
                    { text: "Don’t start the task until asked by supervisors." }]
            };
        case 1:
            return {
                passage: [
                    { type: "p", text: "Where a manual handling task has been assessed as an unacceptable risk, the following controls shall be considered:" },
                    { type: "p", text: "  * Redesign the manual handling task to eliminate or control the risk factors, and" },
                    { type: "p", text: "  * Ensure that mine workers involved in manual handling receive appropriate training." },
                    { type: "p", text: "Where redesign is not practicable, the employer shall:" },
                    { type: "p", text: "  * Provide mechanical aids and/or PPE, and/or arrange for team lifting in order to reduce the risk, and/or" },
                    { type: "p", text: "  * Ensure that mine workers receive appropriate training in methods of manual handling appropriate for that manual  handling task and/or in the correct use of the mechanical aids and/or PPE and/or team lifting procedures." },
                    { type: "p", text: "Mechanical handling equipment should be used if loads cannot be dealt with safely using manual handling techniques. Such equipment includes cranes, hoists, forklifts, jacks etc. There may be hazards associated with using plant such as this and persons are required to be competent and authorised to do so. The implementation of this risk control approach, as with any successful systematic process, does not end with the implementation of some change. The effectiveness of the new controls needs to be reviewed regularly to ensure that the objectives are being achieved and there are no unforeseen negative outcomes." }],
                question: "Which of the following is not required when redesigning a manual handling task is not practical?",
                answer: 2,
                options: [
                    { text: "Provide mechanical aids for assisting with heavy lifting." },
                    { text: "Ask permission before proceeding." },
                    { text: "Ensure mine workers are appropriately trained in methods of manual handling." },
                    { text: "Arrange for others to help with the lifting." }]
            };
        case 2:
            return {
                passage: [
                    { type: "p", text: "Where a manual handling task has been assessed as an unacceptable risk, the following controls shall be considered:" },
                    { type: "p", text: "  * Redesign the manual handling task to eliminate or control the risk factors, and" },
                    { type: "p", text: "  * Ensure that mine workers involved in manual handling receive appropriate training." },
                    { type: "p", text: "Where redesign is not practicable, the employer shall:" },
                    { type: "p", text: "  * Provide mechanical aids and/or PPE, and/or arrange for team lifting in order to reduce the risk, and/or" },
                    { type: "p", text: "  * Ensure that mine workers receive appropriate training in methods of manual handling appropriate for that manual  handling task and/or in the correct use of the mechanical aids and/or PPE and/or team lifting procedures." },
                    { type: "p", text: "Mechanical handling equipment should be used if loads cannot be dealt with safely using manual handling techniques. Such equipment includes cranes, hoists, forklifts, jacks etc. There may be hazards associated with using plant such as this and persons are required to be competent and authorised to do so. The implementation of this risk control approach, as with any successful systematic process, does not end with the implementation of some change. The effectiveness of the new controls needs to be reviewed regularly to ensure that the objectives are being achieved and there are no unforeseen negative outcomes." }],
                question: "What should happen if loads cannot be dealt with safely using manual handling techniques?",
                answer: 1,
                options: [
                    { text: "Mechanical handling equipment should be used." },
                    { text: "The job should be left alone." },
                    { text: "Conduct a hazards analysis on the task." },
                    { text: "Take a minute to identify potential hazards." }]
            };
        case 3:
            return {
                passage: [
                    { type: "p", text: "Where a manual handling task has been assessed as an unacceptable risk, the following controls shall be considered:" },
                    { type: "p", text: "  * Redesign the manual handling task to eliminate or control the risk factors, and" },
                    { type: "p", text: "  * Ensure that mine workers involved in manual handling receive appropriate training." },
                    { type: "p", text: "Where redesign is not practicable, the employer shall:" },
                    { type: "p", text: "  * Provide mechanical aids and/or PPE, and/or arrange for team lifting in order to reduce the risk, and/or" },
                    { type: "p", text: "  * Ensure that mine workers receive appropriate training in methods of manual handling appropriate for that manual  handling task and/or in the correct use of the mechanical aids and/or PPE and/or team lifting procedures." },
                    { type: "p", text: "Mechanical handling equipment should be used if loads cannot be dealt with safely using manual handling techniques. Such equipment includes cranes, hoists, forklifts, jacks etc. There may be hazards associated with using plant such as this and persons are required to be competent and authorised to do so. The implementation of this risk control approach, as with any successful systematic process, does not end with the implementation of some change. The effectiveness of the new controls needs to be reviewed regularly to ensure that the objectives are being achieved and there are no unforeseen negative outcomes." }],
                question: "Mechanical lifting equipment like cranes, hoists, forklifts and jacks can only be used by people who are competent and authorised to operate such equipment, because:",
                answer: 3,
                options: [
                    { text: "The manager's rules states equipment can only be operated by trained personnel." },
                    { text: "State legislation requires such procedures." },
                    { text: "There are likely to be hazards associated with using such equipment." },
                    { text: "Only competent people are authorised to operate such equipment." }]
            };
        case 4:
            return {
                passage: [
                    { type: "p", text: "Where a manual handling task has been assessed as an unacceptable risk, the following controls shall be considered:" },
                    { type: "p", text: "  * Redesign the manual handling task to eliminate or control the risk factors, and" },
                    { type: "p", text: "  * Ensure that mine workers involved in manual handling receive appropriate training." },
                    { type: "p", text: "Where redesign is not practicable, the employer shall:" },
                    { type: "p", text: "  * Provide mechanical aids and/or PPE, and/or arrange for team lifting in order to reduce the risk, and/or" },
                    { type: "p", text: "  * Ensure that mine workers receive appropriate training in methods of manual handling appropriate for that manual  handling task and/or in the correct use of the mechanical aids and/or PPE and/or team lifting procedures." },
                    { type: "p", text: "Mechanical handling equipment should be used if loads cannot be dealt with safely using manual handling techniques. Such equipment includes cranes, hoists, forklifts, jacks etc. There may be hazards associated with using plant such as this and persons are required to be competent and authorised to do so. The implementation of this risk control approach, as with any successful systematic process, does not end with the implementation of some change. The effectiveness of the new controls needs to be reviewed regularly to ensure that the objectives are being achieved and there are no unforeseen" },
                    { type: "p", text: "negative outcomes." }],
                question: "A critical final stage in implementing this risk control approach, is ?",
                answer: 4,
                options: [
                    { text: "Finishing the job with the new and safer method." },
                    { text: "Making sure all ways of doing the job have been considered." },
                    { text: "Identifying frequency of mishaps and their consequences." },
                    { text: "Reviewing the finished job to make sure nothing went wrong." }]
            };
        case 5:
            return {
                passage: [
                    { type: "p", text: "Out of Service Tags prevent the use of unsafe or faulty equipment. Equipment or machinery on which an Out of Service Tag has been placed must not be used or operated, except by a person qualified to ascertain the nature of the equipment malfunction or to move the equipment to a safe position for maintenance." },
                    { type: "p", text: "Whenever a person can foresee that the use of defective equipment or machinery could cause further damage to the equipment or injury to personnel, they must isolate the equipment and attach an Out of Service Tag.  The person shall inform their Supervisor as soon as possible before leaving site. Print information clearly on the Out of Service Tag: name, department, date and time, reason for isolation." },
                    { type: "p", text: "Removal of an Out Of Service Tag is restricted to the following persons after an inspection of the equipment and/or confirmation of completion of appropriate repairs to ensure that it is in proper working order and that its operation will not cause injury to persons or damage to equipment:" },
                    { type: "p", text: "  * The person who placed the tag" },
                    { type: "p", text: "  * A Supervisor, or responsible person appointed by the Supervisor " },
                    { type: "p", text: "  * Persons completing repairs to the equipment." }],
                question: "Out of Service Tags are used:",
                answer: 2,
                options: [
                    { text: "When the service period on machinery has run out." },
                    { text: "To stop people using faulty gear." },
                    { text: "To stop people using machinery that is OK but needs a service." },
                    { text: "To indicate that equipment has been serviced." }]
            };
        case 6:
            return {
                passage: [
                    { type: "p", text: "Out of Service Tags prevent the use of unsafe or faulty equipment. Equipment or machinery on which an Out of Service Tag has been placed must not be used or operated, except by a person qualified to ascertain the nature of the equipment malfunction or to move the equipment to a safe position for maintenance." },
                    { type: "p", text: "Whenever a person can foresee that the use of defective equipment or machinery could cause further damage to the equipment or injury to personnel, they must isolate the equipment and attach an Out of Service Tag.  The person shall inform their Supervisor as soon as possible before leaving site. Print information clearly on the Out of Service Tag: name, department, date and time, reason for isolation." },
                    { type: "p", text: "Removal of an Out Of Service Tag is restricted to the following persons after an inspection of the equipment and/or confirmation of completion of appropriate repairs to ensure that it is in proper working order and that its operation will not cause injury to persons or damage to equipment:" },
                    { type: "p", text: "  * The person who placed the tag" },
                    { type: "p", text: "  * A Supervisor, or responsible person appointed by the Supervisor " },
                    { type: "p", text: "  * Persons completing repairs to the equipment." }],
                question: "Equipment or machinery on which an Out of Service Tag has been placed:",
                answer: 3,
                options: [
                    { text: "Can only be used by a member of the management team." },
                    { text: "Can only be used in an emergency." },
                    { text: "Can only be operated by a qualified person to assess the malfunction or to move it to a safe position for maintenance." },
                    { text: "Must not be used or operated by any person." }]
            };
        case 7:
            return {
                passage: [
                    { type: "p", text: "Out of Service Tags prevent the use of unsafe or faulty equipment. Equipment or machinery on which an Out of Service Tag has been placed must not be used or operated, except by a person qualified to ascertain the nature of the equipment malfunction or to move the equipment to a safe position for maintenance." },
                    { type: "p", text: "Whenever a person can foresee that the use of defective equipment or machinery could cause further damage to the equipment or injury to personnel, they must isolate the equipment and attach an Out of Service Tag.  The person shall inform their Supervisor as soon as possible before leaving site. Print information clearly on the Out of Service Tag: name, department, date and time, reason for isolation." },
                    { type: "p", text: "Removal of an Out Of Service Tag is restricted to the following persons after an inspection of the equipment and/or confirmation of completion of appropriate repairs to ensure that it is in proper working order and that its operation will not cause injury to persons or damage to equipment:" },
                    { type: "p", text: "  * The person who placed the tag" },
                    { type: "p", text: "  * A Supervisor, or responsible person appointed by the Supervisor " },
                    { type: "p", text: "  * Persons completing repairs to the equipment." }],
                question: "Out of Service Tags are attached when:",
                answer: 3,
                options: [
                    { text: "The person appointed to attach Out of Service Tags finds faulty equipment." },
                    { text: "Supervisors find defective equipment." },
                    { text: "When anyone on site suspects equipment is dangerous and after isolating that equipment." },
                    { text: "After advising their supervisor of the faulty equipment." }]
            };
        case 8:
            return {
                passage: [
                    { type: "p", text: "Out of Service Tags prevent the use of unsafe or faulty equipment. Equipment or machinery on which an Out of Service Tag has been placed must not be used or operated, except by a person qualified to ascertain the nature of the equipment malfunction or to move the equipment to a safe position for maintenance." },
                    { type: "p", text: "Whenever a person can foresee that the use of defective equipment or machinery could cause further damage to the equipment or injury to personnel, they must isolate the equipment and attach an Out of Service Tag.  The person shall inform their Supervisor as soon as possible before leaving site. Print information clearly on the Out of Service Tag: name, department, date and time, reason for isolation." },
                    { type: "p", text: "Removal of an Out Of Service Tag is restricted to the following persons after an inspection of the equipment and/or confirmation of completion of appropriate repairs to ensure that it is in proper working order and that its operation will not cause injury to persons or damage to equipment:" },
                    { type: "p", text: "  * The person who placed the tag" },
                    { type: "p", text: "  * A Supervisor, or responsible person appointed by the Supervisor " },
                    { type: "p", text: "  * Persons completing repairs to the equipment." }],
                question: "Whoever attaches an Out of Service Tag:",
                answer: 4,
                options: [
                    { text: "Must conduct repairs to the equipment." },
                    { text: "Must report the incident to the supervisor before their next shift." },
                    { text: "Must sign off on the repairs and/or confirmation of repairs being completed." },
                    { text: "Must tell their supervisor as soon as possible and before leaving site." }]
            };
        case 9:
            return {
                passage: [
                    { type: "p", text: "Out of Service Tags prevent the use of unsafe or faulty equipment. Equipment or machinery on which an Out of Service Tag has been placed must not be used or operated, except by a person qualified to ascertain the nature of the equipment malfunction or to move the equipment to a safe position for maintenance." },
                    { type: "p", text: "Whenever a person can foresee that the use of defective equipment or machinery could cause further damage to the equipment or injury to personnel, they must isolate the equipment and attach an Out of Service Tag.  The person shall inform their Supervisor as soon as possible before leaving site. Print information clearly on the Out of Service Tag: name, department, date and time, reason for isolation." },
                    { type: "p", text: "Removal of an Out Of Service Tag is restricted to the following persons after an inspection of the equipment and/or confirmation of completion of appropriate repairs to ensure that it is in proper working order and that its operation will not cause injury to persons or damage to equipment:" },
                    { type: "p", text: "  * The person who placed the tag" },
                    { type: "p", text: "  * A Supervisor, or responsible person appointed by the Supervisor " },
                    { type: "p", text: "  * Persons completing repairs to the equipment." }],
                question: "According to the SOP, who is permitted to remove an Out of Service Tag?",
                answer: 2,
                options: [
                    { text: "Only the person who placed the tag, and only after they have personally repaired the equipment." },
                    { text: "A supervisor, or someone they appoint, after an inspection confirms that the equipment is in working order." },
                    { text: "A person appointed by the Site Senior Executive." },
                    { text: "A person appointed to remove tags by an Inspector of Mines." }]
            };
        case 10:
            return {
                passage: [
                    { type: "p", text: "It is recognised that employees are required to take medication as prescribed by a Doctor or as medication obtained over the counter from a Pharmacist. Some of these medications have the ability to cause impairment and reduce an employee's fitness for duty. Each employee has an obligation to ensure that any medication taken is done so according to instructions from the Doctor, Pharmacist or information included in or on the packaging of the medication. Where medication advice is that it may cause drowsiness, this shall be discussed with a Supervisor so that suitable duties can be considered prior to the start of work." },
                    { type: "p", text: "Some medications containing amphetamines, codeine phosphate, morphine or synthetic narcotics are detected by drug testing methods. Testing personnel should be able to advise if medications will show positive. Information related to Doctor prescribed and / or Pharmacy medications will be treated confidentially and only be used to consider suitable duties. In the event that a Doctor prescribed or Pharmacy medication  causes a positive drug test, a laboratory test should be conducted to confirm this result." },
                    { type: "p", text: "Employees are to notify and record at the site, the use of any medication that could impair their ability to perform tasks. All matters relating to drug testing and results as a requirement of this procedure shall remain confidential." }],
                question: "According to the text, medication:",
                answer: 2,
                options: [
                    { text: "Can only be prescribed by a pharmacist." },
                    { text: "Should be taken in keeping with the directions." },
                    { text: "Should not be taken before work because it can cause impairment." },
                    { text: "Helps a person to maintain their health." }]
            };
        case 11:
            return {
                passage: [
                    { type: "p", text: "It is recognised that employees are required to take medication as prescribed by a Doctor or as medication obtained over the counter from a Pharmacist. Some of these medications have the ability to cause impairment and reduce an employee's fitness for duty. Each employee has an obligation to ensure that any medication taken is done so according to instructions from the Doctor, Pharmacist or information included in or on the packaging of the medication. Where medication advice is that it may cause drowsiness, this shall be discussed with a Supervisor so that suitable duties can be considered prior to the start of work." },
                    { type: "p", text: "Some medications containing amphetamines, codeine phosphate, morphine or synthetic narcotics are detected by drug testing methods. Testing personnel should be able to advise if medications will show positive. Information related to Doctor prescribed and / or Pharmacy medications will be treated confidentially and only be used to consider suitable duties. In the event that a Doctor prescribed or Pharmacy medication  causes a positive drug test, a laboratory test should be conducted to confirm this result." },
                    { type: "p", text: "Employees are to notify and record at the site, the use of any medication that could impair their ability to perform tasks. All matters relating to drug testing and results as a requirement of this procedure shall remain confidential." }],
                question: "Employees have an obligation to discuss with their supervisor:",
                answer: 3,
                options: [
                    { text: "Any medication they take." },
                    { text: "Only prescribed medication." },
                    { text: "Any medication that might cause impairment." },
                    { text: "All non-prescribed medications." }]
            };
        case 12:
            return {
                passage: [
                    { type: "p", text: "It is recognised that employees are required to take medication as prescribed by a Doctor or as medication obtained over the counter from a Pharmacist. Some of these medications have the ability to cause impairment and reduce an employee's fitness for duty. Each employee has an obligation to ensure that any medication taken is done so according to instructions from the Doctor, Pharmacist or information included in or on the packaging of the medication. Where medication advice is that it may cause drowsiness, this shall be discussed with a Supervisor so that suitable duties can be considered prior to the start of work." },
                    { type: "p", text: "Some medications containing amphetamines, codeine phosphate, morphine or synthetic narcotics are detected by drug testing methods. Testing personnel should be able to advise if medications will show positive. Information related to Doctor prescribed and / or Pharmacy medications will be treated confidentially and only be used to consider suitable duties. In the event that a Doctor prescribed or Pharmacy medication  causes a positive drug test, a laboratory test should be conducted to confirm this result." },
                    { type: "p", text: "Employees are to notify and record at the site, the use of any medication that could impair their ability to perform tasks. All matters relating to drug testing and results as a requirement of this procedure shall remain confidential." }],
                question: "Some people taking medication can test positive on drug testing, because:",
                answer: 4,
                options: [
                    { text: "Some medications should not be taken." },
                    { text: "These people are also taking drugs." },
                    { text: "Some medications are not made to standard." },
                    { text: "Some medications contain the same chemicals found in drugs." }]
            };
        case 13:
            return {
                passage: [
                    { type: "p", text: "It is recognised that employees are required to take medication as prescribed by a Doctor or as medication obtained over the counter from a Pharmacist. Some of these medications have the ability to cause impairment and reduce an employee's fitness for duty. Each employee has an obligation to ensure that any medication taken is done so according to instructions from the Doctor, Pharmacist or information included in or on the packaging of the medication. Where medication advice is that it may cause drowsiness, this shall be discussed with a Supervisor so that suitable duties can be considered prior to the start of work." },
                    { type: "p", text: "Some medications containing amphetamines, codeine phosphate, morphine or synthetic narcotics are detected by drug testing methods. Testing personnel should be able to advise if medications will show positive. Information related to Doctor prescribed and / or Pharmacy medications will be treated confidentially and only be used to consider suitable duties. In the event that a Doctor prescribed or Pharmacy medication  causes a positive drug test, a laboratory test should be conducted to confirm this result." },
                    { type: "p", text: "Employees are to notify and record at the site, the use of any medication that could impair their ability to perform tasks. All matters relating to drug testing and results as a requirement of this procedure shall remain confidential." }],
                question: "It is important for employees to understand the effect of prescribed medications:",
                answer: 2,
                options: [
                    { text: " So they can check the doctor has prescribed the right medication." },
                    { text: "So they know if the medication will influence their alertness and concentration at work." },
                    { text: "So can take the medication according to instructions." },
                    { text: "So they can treat the information confidentially." }]
            };
        case 14:
            return {
                passage: [
                    { type: "p", text: "It is recognised that employees are required to take medication as prescribed by a Doctor or as medication obtained over the counter from a Pharmacist. Some of these medications have the ability to cause impairment and reduce an employee's fitness for duty. Each employee has an obligation to ensure that any medication taken is done so according to instructions from the Doctor, Pharmacist or information included in or on the packaging of the medication. Where medication advice is that it may cause drowsiness, this shall be discussed with a Supervisor so that suitable duties can be considered prior to the start of work." },
                    { type: "p", text: "Some medications containing amphetamines, codeine phosphate, morphine or synthetic narcotics are detected by drug testing methods. Testing personnel should be able to advise if medications will show positive. Information related to Doctor prescribed and / or Pharmacy medications will be treated confidentially and only be used to consider suitable duties. In the event that a Doctor prescribed or Pharmacy medication  causes a positive drug test, a laboratory test should be conducted to confirm this result." },
                    { type: "p", text: "Employees are to notify and record at the site, the use of any medication that could impair their ability to perform tasks. All matters relating to drug testing and results as a requirement of this procedure shall remain confidential." }],
                question: "If a person has taken prescribed medication that might cause drowsiness, reported it to their supervisor, and then tests positive on a drug screening test, what should happen next?",
                answer: 1,
                options: [
                    { text: "A laboratory test should be conducted to confirm the result." },
                    { text: "The person should be stood down." },
                    { text: "The person should be put on alternate duties." },
                    { text: "The results must be kept confidential." }]
            };
        case 15:
            return {
                passage: [
                    { type: "p", text: "Where personnel are required to work within three metres of an opening where they could fall, they shall use personal fall restraint equipment, such as an adjustable lanyard incorporating a shock absorber attached to the fall arrest anchor point of the harness as a minimum, which will prevent them from falling over the edge. Where there is potential to fall more than two metres, personnel shall wear appropriate personal fall arrest equipment. In such circumstances a full body harnesses, including shock-absorbing lanyard or inertia reel, shall be used. The use of body belts for fall arrest is prohibited. " },
                    { type: "p", text: "All fall restraint equipment shall have a shock absorber fitted between the user's harness and the attachment line. The end of the fall restraint shock absorber shall be attached to the harness. All personnel working at heights shall have trauma suspension straps fitted to their harness before commencing any work. All personnel working in an elevated work platform (EWP) or basket shall wear fall restraint equipment attached to an approved anchor point on the platform or basket. " },
                    { type: "p", text: "Single person anchor points shall be capable of withstanding 15 kN (approximately 3,372 foot pounds). If two people are to use the one point, the anchor point shall be capable of withstanding 21kN (approximately 4,721 foot pounds). The maximum number of people connected to any one point shall be two. Where it is not practical to install dedicated anchor points (i.e. ad hoc work), anchor points capable of withstanding 15 kN shall be identified through a risk assessment process and shall be approved by a competent person prior to commencement of work." }],
                question: "People are required to use personal restraint equipment:",
                answer: 1,
                options: [
                    { text: "Where they are working within 3 metres of an opening or where they could fall more than 2 metres." },
                    { text: "Where there is a requirement to work within 3 metres of an edge." },
                    { text: "Where they could fall more than 2 metres." },
                    { text: "Only when instructed to do so by a supervisor." }]
            };
        case 16:
            return {
                passage: [
                    { type: "p", text: "Where personnel are required to work within three metres of an opening where they could fall, they shall use personal fall restraint equipment, such as an adjustable lanyard incorporating a shock absorber attached to the fall arrest anchor point of the harness as a minimum, which will prevent them from falling over the edge. Where there is potential to fall more than two metres, personnel shall wear appropriate personal fall arrest equipment. In such circumstances a full body harnesses, including shock-absorbing lanyard or inertia reel, shall be used. The use of body belts for fall arrest is prohibited. " },
                    { type: "p", text: "All fall restraint equipment shall have a shock absorber fitted between the user's harness and the attachment line. The end of the fall restraint shock absorber shall be attached to the harness. All personnel working at heights shall have trauma suspension straps fitted to their harness before commencing any work. All personnel working in an elevated work platform (EWP) or basket shall wear fall restraint equipment attached to an approved anchor point on the platform or basket. " },
                    { type: "p", text: "Single person anchor points shall be capable of withstanding 15 kN (approximately 3,372 foot pounds). If two people are to use the one point, the anchor point shall be capable of withstanding 21kN (approximately 4,721 foot pounds). The maximum number of people connected to any one point shall be two. Where it is not practical to install dedicated anchor points (i.e. ad hoc work), anchor points capable of withstanding 15 kN shall be identified through a risk assessment process and shall be approved by a competent person prior to commencement of work." }],
                question: "Which of the following is true about required fall restraint equipment?",
                answer: 3,
                options: [
                    { text: "A body belt with shock absorber attached to a line meet the requirements." },
                    { text: "Trauma suspension straps must be fitted to the attached line." },
                    { text: "A shock absorber must be fitted between the body harness and the attachment line." },
                    { text: "The attached line should be fitted directly to the body harness." }]
            };
        case 17:
            return {
                passage: [
                    { type: "p", text: "Where personnel are required to work within three metres of an opening where they could fall, they shall use personal fall restraint equipment, such as an adjustable lanyard incorporating a shock absorber attached to the fall arrest anchor point of the harness as a minimum, which will prevent them from falling over the edge. Where there is potential to fall more than two metres, personnel shall wear appropriate personal fall arrest equipment. In such circumstances a full body harnesses, including shock-absorbing lanyard or inertia reel, shall be used. The use of body belts for fall arrest is prohibited. " },
                    { type: "p", text: "All fall restraint equipment shall have a shock absorber fitted between the user's harness and the attachment line. The end of the fall restraint shock absorber shall be attached to the harness. All personnel working at heights shall have trauma suspension straps fitted to their harness before commencing any work. All personnel working in an elevated work platform (EWP) or basket shall wear fall restraint equipment attached to an approved anchor point on the platform or basket. " },
                    { type: "p", text: "Single person anchor points shall be capable of withstanding 15 kN (approximately 3,372 foot pounds). If two people are to use the one point, the anchor point shall be capable of withstanding 21kN (approximately 4,721 foot pounds). The maximum number of people connected to any one point shall be two. Where it is not practical to install dedicated anchor points (i.e. ad hoc work), anchor points capable of withstanding 15 kN shall be identified through a risk assessment process and shall be approved by a competent person prior to commencement of work." }],
                question: "Trauma suspension straps",
                answer: 2,
                options: [
                    { text: "Should be fitted to the attached line." },
                    { text: "Should be fitted to the body harness before commencing work." },
                    { text: "Are attached to the anchor point to make sure the anchor point is stable." },
                    { text: " Postpone the trauma caused by a fall." }]
            };
        case 18:
            return {
                passage: [
                    { type: "p", text: "Where personnel are required to work within three metres of an opening where they could fall, they shall use personal fall restraint equipment, such as an adjustable lanyard incorporating a shock absorber attached to the fall arrest anchor point of the harness as a minimum, which will prevent them from falling over the edge. Where there is potential to fall more than two metres, personnel shall wear appropriate personal fall arrest equipment. In such circumstances a full body harnesses, including shock-absorbing lanyard or inertia reel, shall be used. The use of body belts for fall arrest is prohibited. " },
                    { type: "p", text: "All fall restraint equipment shall have a shock absorber fitted between the user's harness and the attachment line. The end of the fall restraint shock absorber shall be attached to the harness. All personnel working at heights shall have trauma suspension straps fitted to their harness before commencing any work. All personnel working in an elevated work platform (EWP) or basket shall wear fall restraint equipment attached to an approved anchor point on the platform or basket. " },
                    { type: "p", text: "Single person anchor points shall be capable of withstanding 15 kN (approximately 3,372 foot pounds). If two people are to use the one point, the anchor point shall be capable of withstanding 21kN (approximately 4,721 foot pounds). The maximum number of people connected to any one point shall be two. Where it is not practical to install dedicated anchor points (i.e. ad hoc work), anchor points capable of withstanding 15 kN shall be identified through a risk assessment process and shall be approved by a competent person prior to commencement of work." }],
                question: "People working on an elevated work platform should ensure the line is attached to:",
                answer: 4,
                options: [
                    { text: "A part of the platform that is secure." },
                    { text: "An anchor point separate from and above the platform." },
                    { text: "An anchor point." },
                    { text: "An approved anchor point on the platform." }]
            };
        case 19:
            return {
                passage: [
                    { type: "p", text: "Where personnel are required to work within three metres of an opening where they could fall, they shall use personal fall restraint equipment, such as an adjustable lanyard incorporating a shock absorber attached to the fall arrest anchor point of the harness as a minimum, which will prevent them from falling over the edge. Where there is potential to fall more than two metres, personnel shall wear appropriate personal fall arrest equipment. In such circumstances a full body harnesses, including shock-absorbing lanyard or inertia reel, shall be used. The use of body belts for fall arrest is prohibited. " },
                    { type: "p", text: "All fall restraint equipment shall have a shock absorber fitted between the user's harness and the attachment line. The end of the fall restraint shock absorber shall be attached to the harness. All personnel working at heights shall have trauma suspension straps fitted to their harness before commencing any work. All personnel working in an elevated work platform (EWP) or basket shall wear fall restraint equipment attached to an approved anchor point on the platform or basket. " },
                    { type: "p", text: "Single person anchor points shall be capable of withstanding 15 kN (approximately 3,372 foot pounds). If two people are to use the one point, the anchor point shall be capable of withstanding 21kN (approximately 4,721 foot pounds). The maximum number of people connected to any one point shall be two. Where it is not practical to install dedicated anchor points (i.e. ad hoc work), anchor points capable of withstanding 15 kN shall be identified through a risk assessment process and shall be approved by a competent person prior to commencement of work." }],
                question: "Three people working on an elevated platform would require:",
                answer: 3,
                options: [
                    { text: "An anchor point capable of withstanding 36 kN." },
                    { text: "The procedure prohibits three people on a single platform." },
                    { text: "Two separate anchor points with at least one capable of withstanding 21 kN." },
                    { text: "Two separate anchor points both capable of withstanding 15 kN." }]
            };
        default:
            return null;
    }
}

function getNumeracyIntro() {
    return {
        elems: [
            { type: "h1", text: "NUMERACY", icon: "far fa-abacus" },
            {
                type: "g", elems: [
                    { type: "p", text: "This test measures your ability to solve simple numerical problems based on workplace situations." }]
            }]
    };
}

function getNumeracyInstructions() {
    return {
        disableNext: true,
        elems: [
            {
                type: "t",
                elems: [
                    {
                        type: "-",
                        tabId: 1,
                        elems: [
                            { type: "p", text: "You will see 12 numerical questions, like this practice one. You may use pencil and paper calculations, but do NOT use a calculator." }]
                    },
                    {
                        type: "-",
                        tabId: 2,
                        elems: [
                            { type: "p", text: "Each question has either 2, 3, or 4 potential answers - but only one of these is correct in each case." }]
                    },
                    {
                        type: "-",
                        tabId: 3,
                        elems: [
                            { type: "p", text: "You can change your answer as often as you like until you lock it in by clicking on the NEXT button." }]
                    },
                    {
                        type: "-",
                        tabId: 4,
                        elems: [
                            { type: "p", text: "When you are ready, select the correct answer for the practice question below and click NEXT to start the test." }]
                    }]
            }],
        question: "If a garbage bin holds 40 litres of waste, how many bins will it take to fill a trailer with a capacity of 1200 litres?",
        options: [
            { text: "20" },
            { text: "30" },
            { text: "40" }]
    };
}

function getNumeracyContent(index) {
    switch (index) {
        case 0:
            return {
                question: "If a high pressure hose releases 120 litres of water per minute, how much water will it release in 20 seconds?",
                answer: 3,
                options: [
                    { text: "6 litres" },
                    { text: "140 litres" },
                    { text: "40 litres" },
                    { text: "25 litres" }]
            };
        case 1:
            return {
                question: "There is 10 days supply of a material in the store. It takes 7 days for new supplies to arrive after ordering. At the very latest, how many days before you must order more of the material?",
                answer: 1,
                options: [
                    { text: "3 days" },
                    { text: "7 days" },
                    { text: "10 days" },
                    { text: "17 days" }]
            };
        case 2:
            return {
                question: "Jim operates a dragline that can shift 250 tonnes of coal per lift. How much coal can Jim shift in 6 lifts?",
                answer: 3,
                options: [
                    { text: "1000 tonnes" },
                    { text: "1250 tonnes" },
                    { text: "1500 tonnes" },
                    { text: "1750 tonnes" }]
            };
        case 3:
            return {
                question: "If Tom works a 12 hour shift then 2 hours overtime at double time, how many hours work is he paid for?",
                answer: 1,
                options: [
                    { text: "16 hours" },
                    { text: "14 hours" },
                    { text: "12 hours" },
                    { text: "10 hours" }]
            };
        case 4:
            return {
                question: "You are checking tyre pressure and it is 26psi. The required tyre pressure is 37psi. How much more pressure do you need to put in the tyre?",
                answer: 2,
                options: [
                    { text: "63 psi" },
                    { text: "11 psi" }]
            };
        case 5:
            return {
                question: "You are monitoring the temperature of a process which is currently operating at 250°C. You are instructed to reduce the temperature by half. What temperature should you adjust the process to?",
                answer: 3,
                options: [
                    { text: "500 °C" },
                    { text: "250 °C" },
                    { text: "125 °C" },
                    { text: "62.5 °C" }]
            };
        case 6:
            return {
                question: "A pile of trash needs to be put in a bin. It will take you 15 minutes to do this on your own. How long would it take if you had two other workers to help you?",
                answer: 1,
                options: [
                    { text: "5 minutes" },
                    { text: "45 minutes" },
                    { text: "7.5 minutes" }]
            };
        case 7:
            return {
                question: "A piece of tube steel 30 centimetres long needs to be cut into two pieces, one twice as long as the other. John cut the longest piece to 20cm. Did he cut it to the right length?",
                answer: 1,
                options: [
                    { text: "Yes" },
                    { text: "No" }]
            };
        case 8:
            return {
                question: "Ted works a 12 hour shift with 30 minute hot-seat change. His travel time from work to home is 45 minutes one way. The minimum time Ted is away from home each day is 13 hours 15 minutes.",
                answer: 2,
                options: [
                    { text: "True" },
                    { text: "False" }]
            };
        case 9:
            return {
                question: "If it takes 12 minutes to drive the haul truck from loading to unloading and the truck averages 10 kilometres per hour, how far does the truck travel each trip?",
                answer: 3,
                options: [
                    { text: "4 km" },
                    { text: "3 km" },
                    { text: "2 km" },
                    { text: "1 km" }]
            };
        case 10:
            return {
                question: "Is 25 the missing number in this sequence?",
                questionItems: ["4", "8", "7", "14", "13", "26", "?", "50"],
                answer: 1,
                options: [
                    { text: "Yes" },
                    { text: "No" }]
            };
        case 11:
            return {
                question: "There are 8 tradesmen on site. There are three times as many fitters as electricians. How many fitters are there on site?",
                answer: 1,
                options: [
                    { text: "6" },
                    { text: "4" },
                    { text: "2" }]
            };
        default:
            return null;
    }
}

function getAbstractReasoningIntro() {
    return {
        elems: [
            { type: "h1", text: "ABSTRACT REASONING", icon: "far fa-shapes" },
            { type: "h2", text: "Find the pattern and what's missing?" },
            {
                type: "g", elems: [
                    { type: "p", text: "This test measures your ability to solve abstract problems." },
                    { type: "p", text: "You have 20 minutes to go through 25 sets of shapes, identify the pattern and find what's missing." }]
            }]
    };
}

function getAbstractReasoningInstructions() {
    return {
        disableNext: true,
        elems: [
            {
                type: "t",
                elems: [
                    {
                        type: "-",
                        tabId: 1,
                        elems: [
                            {
                                type: "p", text: "For each set of shapes there is a missing part marked by a red question mark. Your task is to recognise the pattern across each row, and then select the one answer from the six possible answers below that completes the pattern."
                            }]
                    },
                    {
                        type: "-",
                        tabId: 2,
                        elems: [
                            { type: "p", text: "Once you click on the NEXT button, your answer will be locked in." }]
                    },
                    {
                        type: "-",
                        tabId: 3,
                        elems: [
                            { type: "p", text: "You can go back to a previous question using the BACK button (you can skip difficult questions and return to them later if you have time)." }]
                    },
                    {
                        type: "-",
                        tabId: 4,
                        elems: [
                            { type: "p", text: "If you finish before the 20 minute time limit is up, you can click the END button to exit this test." },
                            { type: "p", text: "DO NOT do this unless you are certain that you have finished." }]
                    },
                    {
                        type: "-",
                        tabId: 5,
                        elems: [
                            { type: "p", text: "When you are ready, select the correct answer for the missing pattern below and click NEXT to begin." }]
                    }]
            }],
        question: "If a garbage bin holds 40 litres of waste, how many bins will it take to fill a trailer with a capacity of 1200 litres?",
        options: [
            { text: "20" },
            { text: "30" },
            { text: "40" }]
    };
}

function getMechanicalReasoningIntro() {
    return {
        elems: [
            { type: "h1", text: "MECHANICAL REASONING", icon: "far fa-cogs" },
            {
                type: "g", elems: [
                    { type: "p", text: "This test measures your ability to solve mechanical or spatial problems." },
                    { type: "p", text: "You'll have 15 minutes to solve 20 different problems." }]
            }]
    };
}

function getMechanicalReasoningInstructions() {
    return {
        disableNext: true,
        elems: [
            {
                type: "t",
                elems: [
                    {
                        type: "-",
                        tabId: 1,
                        elems: [
                            {
                                type: "p", text: "Each problem consists of a written question and a graphic showing the situation the question relates to."
                            }]
                    },
                    {
                        type: "-",
                        tabId: 2,
                        elems: [
                            { type: "p", text: "Select the correct answer, then click on the NEXT button to move on to the next problem." }]
                    },
                    {
                        type: "-",
                        tabId: 3,
                        elems: [
                            { type: "p", text: "You can go back to a previous question using the BACK button (you can skip difficult questions and return to them later if you have time)." }]
                    },
                    {
                        type: "-",
                        tabId: 4,
                        elems: [
                            { type: "p", text: "If you finish before the 15 minute time limit is up, you can click the END button to exit this test." },
                            { type: "p", text: "DO NOT do this unless you are certain that you have finished." }]
                    },
                    {
                        type: "-",
                        tabId: 5,
                        elems: [
                            { type: "p", text: "When you are ready, select the answer you believe is correct below and click NEXT to begin." }]
                    }]
            }],
        question: "If I push down at point A, what will happen at points B and C?",
        options: [
            { text: "Points B and C will go up" },
            { text: "Points B and C will go down" },
            { text: "Point B will go up and point C will go down" },
            { text: "Point B will go down and point C will go up" }]
    };
}

function getMechanicalReasoningContent(index) {
    switch (index) {
        case 0:
            return {
                question: "Can any gear turn in the same direction as B?",
                answer: 3,
                options: [
                    { text: "Yes, only A" },
                    { text: "Yes, only C" },
                    { text: "No, neither A nor C" },
                    { text: "Yes, both A and C" }]
            };
        case 1:
            return {
                question: "How many of these wheels can turn in the same direction at the same time?",
                answer: 3,
                options: [
                    { text: "One" },
                    { text: "Two" },
                    { text: "Three" },
                    { text: "Four" }]
            };
        case 2:
            return {
                question: "If levers A, B and C are pushed down with equal force at the points indicated by the arrows, which lever will move the weight higher into the air?",
                answer: 1,
                options: [
                    { text: "Lever A" },
                    { text: "Lever B" },
                    { text: "Lever C" },
                    { text: "The answer can't be determined from this information." }]
            };
        case 3:
            return {
                question: "If rope D breaks, which shock absorber will experience the greatest force?",
                answer: 1,
                options: [
                    { text: "Shock absorber A" },
                    { text: "Shock absorber B" },
                    { text: "Shock absorber C" },
                    { text: "Shock absorbers A, B, and C will all experience the same force." }]
            };
        case 4:
            return {
                question: "If piston A is ascending then,",
                answer: 2,
                options: [
                    { text: "Pistons B and C are ascending" },
                    { text: "Pistons B and C are descending" },
                    { text: "Piston B is ascending and piston C is descending" },
                    { text: "Piston B is descending and piston C is ascending" }]
            };
        case 5:
            return {
                question: "The four gears (A, B, C and D) all rotate in the same direction to push the three rods back and forward. Which gear/s will wear most rapidly?",
                answer: 1,
                options: [
                    { text: "Gears B and C" },
                    { text: "Gears A and D" },
                    { text: "Gear A" },
                    { text: "All will wear at the same rate" }]
            };
        case 6:
            return {
                question: "If the purple roller is slid down the slot as shown by the black arrow, in which direction will the white non-fixed pivot move?",
                answer: 3,
                options: [
                    { text: "Direction A" },
                    { text: "Direction B" },
                    { text: "Direction C" },
                    { text: "Direction D" }]
            };
        case 7:
            return {
                question: "Gear A has 20 teeth and gear B has 50 teeth. If gear B turns through three revolutions, how many revolutions will gear A complete?",
                answer: 2,
                options: [
                    { text: "Three revolutions" },
                    { text: "Seven and a half revolutions" },
                    { text: "One and a fifth revolutions" },
                    { text: "One revolution" }]
            };
        case 8:
            return {
                question: "If gear C turns clockwise, how will gears A and E turn?",
                answer: 1,
                options: [
                    { text: "A and E will both turn clockwise" },
                    { text: "A and E will both turn counterclockwise" },
                    { text: "A will turn clockwise and E will turn counterclockwise" },
                    { text: "A will turn counter clockwise and E will turn clockwise" }]
            };
        case 9:
            return {
                question: "If lever A is pushed to the RIGHT as shown, which direction will the TOP of lever B move?",
                answer: 1,
                options: [
                    { text: "Right" },
                    { text: "Left" },
                    { text: "Up" },
                    { text: "Down" }]
            };
        case 10:
            return {
                question: "If wheel C turns counterclockwise then,",
                answer: 2,
                options: [
                    { text: "A and B will both turn clockwise" },
                    { text: "A and B will both turn counterclockwise" },
                    { text: "A will turn clockwise and B will turn counterclockwise" },
                    { text: "A will turn counter clockwise and B will turn clockwise" }]
            };
        case 11:
            return {
                question: "If gear A is turning clockwise, how many gears in total (that is including A) are turning clockwise?",
                answer: 3,
                options: [
                    { text: "One" },
                    { text: "Two" },
                    { text: "Three" },
                    { text: "Four" }]
            };
        case 12:
            return {
                question: "The motor drives belts A, B, C and D. If everything except the Fan and Conveyer 1 are working, which of the following is the best explanation of what is wrong with the system?",
                answer: 4,
                options: [
                    { text: "Belt A is broken" },
                    { text: "Belt C is broken" },
                    { text: "Belts A and B are broken" },
                    { text: "Belt B is broken and the fan is faulty" }]
            };
        case 13:
            return {
                question: "The constant speed motor drives the pump via a belt attached between wheels A, B or C. Which pair of wheels should the belt be attached to in order to drive the pump at the highest speed?",
                answer: 3,
                options: [
                    { text: "Wheels C" },
                    { text: "Wheels B" },
                    { text: "Wheels A" },
                    { text: "Wheels A, B, and C would all turn the pump at the same speed" }]
            };
        case 14:
            return {
                question: "To move weight B up 30mm, weight A must be moved,",
                answer: 2,
                options: [
                    { text: "Down 30mm" },
                    { text: "Down 60mm" },
                    { text: "Up 30mm" },
                    { text: "Down 15mm" }]
            };
        case 15:
            return {
                question: "Can the motor drive all these wheels?",
                answer: 4,
                options: [
                    { text: "Yes, if it runs clockwise" },
                    { text: "Yes regardless of the direction of rotation" },
                    { text: "No, because some of the wheels turn at different speeds" },
                    { text: "No, because some of the wheels turn in different directions" }]
            };
        case 16:
            return {
                question: "Wheel A rotates behind wheel B and drives it via pin C. Which of the following is true?",
                answer: 4,
                options: [
                    { text: "Wheel B rotates at seven times the speed of wheel A" },
                    { text: "Wheel B rotates at the same speed as wheel A" },
                    { text: "This mechanism will jam" },
                    { text: "Wheel A rotates at seven times the speed of wheel B" }]
            };
        case 17:
            return {
                question: "Cam A can turn in either direction to operate valve B and spring C. If valve B has been opened and closed six times, which of the following CANNOT be true?",
                answer: 4,
                options: [
                    { text: "Cam A has rotated three times clockwise" },
                    { text: "Cam A has rotated two times clockwise and then once counterclockwise" },
                    { text: "Cam A has rotated once clockwise and then two times counterclockwise" },
                    { text: "Cam A has rotated six times clockwise" }]
            };
        case 18:
            return {
                question: "Wheel A rotates at a constant speed and drives wheel B. If wheel A is moved up the shaft as shown by the arrow, what will happen to wheel B?",
                answer: 2,
                options: [
                    { text: "Wheel B will speed up and turn in the same direction as wheel A" },
                    { text: "Wheel B will speed up and turn in the opposite direction to wheel A" },
                    { text: "Wheel B will slow down and turn in the same direction as wheel A" },
                    { text: "Wheel B will slow down and turn in the opposite direction to wheel A" }]
            };
        case 19:
            return {
                question: "Wheels A and B are 200mm in diameter. Wheels C and D are 400mm in diameter. If wheel D rotates once, how many times will wheel A rotate?",
                answer: 4,
                options: [
                    { text: "Once" },
                    { text: "Twice" },
                    { text: "Three times" },
                    { text: "Four times" }]
            };
        default:
            return null;
    }
}

function getNumericalReasoningIntro() {
    return {
        elems: [
            { type: "h1", text: "NUMERICAL REASONING", icon: "far fa-function" },
            {
                type: "g", elems: [
                    { type: "p", text: "This test measures your ability to solve numerical and logical problems." },
                    { type: "p", text: "You'll have 20 minutes to solve 30 different problems." }]
            }]
    };
}

function getNumericalReasoningInstructions() {
    return {
        disableNext: true,
        elems: [
            {
                type: "t",
                elems: [
                    {
                        type: "-",
                        tabId: 1,
                        elems: [
                            { type: "p", text: "For each question, the answer is a number between 1 and 99." },
                            { type: "p", text: "You may use pencil and paper calculations, but do NOT use a calculator." }]
                    },
                    {
                        type: "-",
                        tabId: 2,
                        elems: [
                            { type: "p", text: "Type the correct answer, then click on the NEXT button to move on to the next problem." }]
                    },
                    {
                        type: "-",
                        tabId: 3,
                        elems: [
                            { type: "p", text: "You can go back to a previous question using the BACK button (you can skip difficult questions and return to them later if you have time)." }]
                    },
                    {
                        type: "-",
                        tabId: 4,
                        elems: [
                            { type: "p", text: "If you finish before the 20 minute time limit is up, you can click the END button to exit this test." },
                            { type: "p", text: "DO NOT do this unless you are certain that you have finished." }]
                    },
                    {
                        type: "-",
                        tabId: 5,
                        elems: [
                            { type: "p", text: "When you are ready, type the answer for the practice question below and click NEXT to begin." }]
                    }]
            }],
        question: "What is the missing number (indicated by ?) in the following list:",
        options: [
            { text: "10" },
            { text: "20" },
            { text: "?" },
            { text: "40" },
            { text: "50" },
            { text: "60" },
            { text: "70" }]
    };
}

function getNumericalReasoningContent(index) {
    switch (index) {
        case 0:
            return {
                question: "What is the missing number (indicated by ?) in the following list:",
                answer: 23,
                options: [
                    { text: "25" },
                    { text: "5" },
                    { text: "24" },
                    { text: "4" },
                    { text: "?" },
                    { text: "3" },
                    { text: "22" }]
            };
        case 1:
            return {
                question: "Belt A can move 70 units of ore per shift. Belt B can move one seventh as much ore per shift as Belt A. Belt C can move three times as much ore per shift as Belt B. How much ore does Belt C move per shift?",
                answer: 30,
                options: []
            };
        case 2:
            return {
                question: "Ted took 4 times as long as John to load 2000 units of ore. John loaded 1000 units of ore per hour. How many hours did it take Ted to load all of his ore?",
                answer: 8,
                options: []
            };
        case 3:
            return {
                question: "What is the missing number (indicated by ?) in this list:",
                answer: 4,
                options: [
                    { text: "8" },
                    { text: "?" },
                    { text: "9" },
                    { text: "5" },
                    { text: "10" },
                    { text: "6" }]
            };
        case 4:
            return {
                question: "If 7 drill bits cost $49 if purchased individually, but a boxed set of 7 bits costs one-third as much, how many boxed drill bits could you buy for $49?",
                answer: 21,
                options: []
            };
        case 5:
            return {
                question: "The following three sets of numbers all follow the same pattern. What number should go where the question mark is?",
                answer: 12,
                options: [
                    { text: "[3,1,6]" },
                    { text: "[5,3,-]" },
                    { text: "[14,?,17]" }]
            };
        case 6:
            return {
                question: "A 60cm length of pipe has to be cut into 4 parts with each successive part being twice as long as the previous part. What is the length in centimetres of the shortest part?",
                answer: 4,
                options: []
            };
        case 7:
            return {
                question: "What is the missing number (indicated by ?) in this list?",
                answer: 3,
                options: [
                    { text: "1" },
                    { text: "?" },
                    { text: "4" },
                    { text: "6" },
                    { text: "7" },
                    { text: "9" },
                    { text: "-" },
                    { text: "12" },
                    { text: "13" }]
            };
        case 8:
            return {
                question: "Production Line A has been injury free for 3 days and Line B has been injury free for 11 days. Assuming that no accidents occur on either line, in how many days will Line B have been injury free for exactly twice as many days as Line A?",
                answer: 5,
                options: []
            };
        case 9:
            return {
                question: "The company store received 16 pallets of supplies (oil and degreaser). There are 3 times as many pallets of oil as there are of degreaser. How many pallets of oil did the store receive?",
                answer: 12,
                options: []
            };
        case 10:
            return {
                question: "The following three sets of numbers all follow the same pattern. What number should go where the question mark is?",
                answer: 38,
                options: [
                    { text: "[3,6,12]" },
                    { text: "[7,-,28]" },
                    { text: "[19,?,76]" }]
            };
        case 11:
            return {
                question: "The product of two positive numbers is 60 and their difference is 11. What is the larger of the two numbers?",
                answer: 15,
                options: []
            };
        case 12:
            return {
                question: "What is the missing number (indicated by ?) in this list?",
                answer: 17,
                options: [
                    { text: "3" },
                    { text: "6" },
                    { text: "5" },
                    { text: "-" },
                    { text: "9" },
                    { text: "18" },
                    { text: "?" },
                    { text: "34" }]
            };
        case 13:
            return {
                question: "There are 92 washers in a box containing only 25mm and 30mm washers. There are 10 more 25mm washers than 30mm washers. How many 30mm washers are there in the box?",
                answer: 41,
                options: []
            };
        case 14:
            return {
                question: "Truck A covers 30km in the time Truck B covers 27km. How many kilometres behind will Truck B be after Truck A has covered 150km?",
                answer: 15,
                options: []
            };
        case 15:
            return {
                question: "A two-part adhesive is mixed 3 parts base and 2 parts catalyst. How many litres of base will it take to make 15 litres of adhesive?",
                answer: 9,
                options: []
            };
        case 16:
            return {
                question: "What is the missing number (indicated by ?) in this list?",
                answer: 13,
                options: [
                    { text: "31" },
                    { text: "25" },
                    { text: "20" },
                    { text: "16" },
                    { text: "?" },
                    { text: "11" },
                    { text: "-" },
                    { text: "10" }]
            };
        case 17:
            return {
                question: "Two 1.7 metre lengths of timber are cut from an initial piece 9.4 metres in length. How many metres of the initial piece are left over?",
                answer: 6,
                options: []
            };
        case 18:
            return {
                question: "A shift manager tries to organise a group of workers into teams to do separate tasks. If they are put in groups of 4 there are 3 workers left over, if in groups of 3 there are 2 left over, and if in groups of 2 there is 1 left over. Assuming that there are less than 20 workers in total, how many workers must there be?",
                answer: 11,
                options: []
            };
        case 19:
            return {
                question: "The sum of two numbers is 32 and the larger one divided by the smaller one equals 3. What is the larger of these two numbers?",
                answer: 24,
                options: []
            };
        case 20:
            return {
                question: "A perfectly straight road runs through the site from the mine entrance to the car park passing directly by the store and site office on the way. The mine entrance is 50 metres from the store. The store is 150 metres from the car park. The site office is midway between the car park and the mine entrance. How far is it from the site office to the store?",
                answer: 50,
                options: []
            };
        case 21:
            return {
                question: "A site has 360 staff. Two-thirds of the staff works in the mine. Half of the remaining staff works in maintenance. Management, logistics, and accounting staff fill all the remaining positions in equal proportions. How many staff work in logistics?",
                answer: 20,
                options: []
            };
        case 22:
            return {
                question: "What is the missing number (indicated by ?) in this list?",
                answer: 48,
                options: [
                    { text: "97" },
                    { text: "84" },
                    { text: "73" },
                    { text: "64" },
                    { text: "57" },
                    { text: "-" },
                    { text: "49" },
                    { text: "?" }]
            };
        case 23:
            return {
                question: "After compacting, 30 loads of ore fit into 20 railway cars. How many railway cars are needed to hold 108 loads of ore after compacting?",
                answer: 72,
                options: []
            };
        case 24:
            return {
                question: "What is the missing number (indicated by ?) in this list?",
                answer: 54,
                options: [
                    { text: "2" },
                    { text: "6" },
                    { text: "-" },
                    { text: "?" },
                    { text: "162" },
                    { text: "486" },
                    { text: "1458" }]
            };
        case 25:
            return {
                question: "Ore costs $15 per ton to produce. The market price is such that the mine earns as much when it sells 3 tons of ore as it costs to produce 4 tons. What is the market price in dollars of ore per ton?",
                answer: 20,
                options: []
            };
        case 26:
            return {
                question: "The hourly salary for electricians is the same as that for fitters, but only half that of a shift manager. If it costs $192 per hour to employ 2 electricians, 2 fitters, and 2 shift managers, how many dollars is each shift manager paid per hour?",
                answer: 48,
                options: []
            };
        case 27:
            return {
                question: "It took 1 hour and 40 minutes to complete a production process. A new machine was purchased which reduced the production time to 1 hour and 20 minutes. By what percentage has the production time been improved?",
                answer: 20,
                options: []
            };
        case 28:
            return {
                question: "What is the missing number (indicated by ?) in this list?",
                answer: 32,
                options: [
                    { text: "54" },
                    { text: "45" },
                    { text: "43" },
                    { text: "34" },
                    { text: "?" },
                    { text: "23" },
                    { text: "21" },
                    { text: "-" }]
            };
        case 29:
            return {
                question: "A mine makes the same profit by selling refined product at $80 per 100 kilograms or $60 per bucket load. What is average weight in kilograms of a bucket load?",
                answer: 75,
                options: []
            };
        default:
            return null;
    }
}

function getVerbalReasoningIntro() {
    return {
        elems: [
            { type: "h1", text: "VERBAL REASONING", icon: "far fa-quote-left" },
            {
                type: "g", elems: [
                    { type: "p", text: "This test measures your knowledge of words and their meaning." },
                    { type: "p", text: "You'll have 20 minutes to answer 30 different questions." }]
            }]
    };
}

function getVerbalReasoningInstructions() {
    return {
        disableNext: true,
        elems: [
            {
                type: "t",
                elems: [
                    {
                        type: "-",
                        tabId: 1,
                        elems: [
                            { type: "p", text: "Some of the questions require you to choose one option, other questions require you to select two options." }]
                    },
                    {
                        type: "-",
                        tabId: 2,
                        elems: [
                            { type: "p", text: "You can go to the next question by using the NEXT button or back to a previous question by using the BACK button (you can skip difficult questions and return to them later if you have time)." }]
                    },
                    {
                        type: "-",
                        tabId: 3,
                        elems: [
                            { type: "p", text: "You can change your answer as often as you like until you change the question by either clicking on the NEXT or BACK button. To cancel a selection, just click on that item again." }]
                    },
                    {
                        type: "-",
                        tabId: 4,
                        elems: [
                            { type: "p", text: "If you finish before the 20 minute time limit is up, you can click the END button to exit this test." },
                            { type: "p", text: "DO NOT do this unless you are certain that you have finished." }]
                    },
                    {
                        type: "-",
                        tabId: 5,
                        elems: [
                            { type: "p", text: "When you are ready, select the answer you believe is correct below and click NEXT to begin." }]
                    }]
            }],
        question: "CAT is to KITTEN as DOG is to:",
        options: [
            { text: "Puppy" },
            { text: "Baby" },
            { text: "Infant" },
            { text: "Child" },
            { text: "Young" }]
    };
}

function getVerbalReasoningContent(index) {
    switch (index) {
        case 0:
            return {
                question: "FOUR of the following words are ALIKE in terms of their meaning. Please select the other TWO WORDS.",
                responses: 2,
                answer: 36,
                options: [
                    { text: "Separate" },
                    { text: "Disperse" },
                    { text: "Collect" },
                    { text: "Disband" },
                    { text: "Scatter" },
                    { text: "Guide" }]
            };
        case 1:
            return {
                question: "FOUR of the following words are ALIKE in terms of their meaning. Please select the other TWO WORDS.",
                responses: 2,
                answer: 14,
                options: [
                    { text: "Length" },
                    { text: "Maxim" },
                    { text: "Saying" },
                    { text: "Star" },
                    { text: "Proverb" },
                    { text: "Truism" }]
            };
        case 2:
            return {
                question: "FOUR of the following words are ALIKE in terms of their meaning. Please select the other TWO WORDS.",
                responses: 2,
                answer: 36,
                options: [
                    { text: "Protection" },
                    { text: "Rail" },
                    { text: "Time" },
                    { text: "Guard" },
                    { text: "Cover" },
                    { text: "Watch" }]
            };
        case 3:
            return {
                question: "FOUR of the following words are ALIKE in terms of their meaning. Please select the other TWO WORDS.",
                responses: 2,
                answer: 26,
                options: [
                    { text: "Direct" },
                    { text: "Axiom" },
                    { text: "Show" },
                    { text: "Point" },
                    { text: "Pilot" },
                    { text: "Space" }]
            };
        case 4:
            return {
                question: "FOUR of the following words are ALIKE in terms of their meaning. Please select the other TWO WORDS.",
                responses: 2,
                answer: 15,
                options: [
                    { text: "Defence" },
                    { text: "Span" },
                    { text: "Extent" },
                    { text: "Duration" },
                    { text: "Sword" },
                    { text: "Length" }]
            };
        case 5:
            return {
                question: "FOUR of the following words are ALIKE in terms of their meaning. Please select the other TWO WORDS.",
                responses: 2,
                answer: 35,
                options: [
                    { text: "Trial" },
                    { text: "Test" },
                    { text: "Freedom" },
                    { text: "Experiment" },
                    { text: "Degree" },
                    { text: "Analysis" }]
            };
        case 6:
            return {
                question: "FOUR of the following words are ALIKE in terms of their meaning. Please select the other TWO WORDS.",
                responses: 2,
                answer: 13,
                options: [
                    { text: "Impermeable" },
                    { text: "Proof" },
                    { text: "Resistant" },
                    { text: "Evidence" },
                    { text: "Confirmation" },
                    { text: "Corroboration" }]
            };
        case 7:
            return {
                question: "FOUR of the following words are ALIKE in terms of their meaning. Please select the other TWO WORDS.",
                responses: 2,
                answer: 35,
                options: [
                    { text: "Resilient" },
                    { text: "Hardy" },
                    { text: "Elastic" },
                    { text: "Tough" },
                    { text: "Pliant" },
                    { text: "Durable" }]
            };
        case 8:
            return {
                question: "SQUARE is to CIRCLE as CUBE is to:",
                responses: 1,
                answer: 3,
                options: [
                    { text: "Circumference" },
                    { text: "Diameter" },
                    { text: "Sphere" },
                    { text: "Radius" },
                    { text: "Cylinder" }]
            };
        case 9:
            return {
                question: "TIME is to INSTANT as SPACE is to:",
                responses: 1,
                answer: 4,
                options: [
                    { text: "Eternal" },
                    { text: "Cosmos" },
                    { text: "Linear" },
                    { text: "Point" },
                    { text: "Location" }]
            };
        case 10:
            return {
                question: "PERMISSIVE is to AUTHORITARIAN as IGNORANT is to:",
                responses: 1,
                answer: 5,
                options: [
                    { text: "Opinionated" },
                    { text: "Search" },
                    { text: "Guidance" },
                    { text: "Confidence" },
                    { text: "Informed" }]
            };
        case 11:
            return {
                question: "PRACTICE is to PREPARATION as PROCEDURE is to:",
                responses: 1,
                answer: 3,
                options: [
                    { text: "Proclamation" },
                    { text: "Declaration" },
                    { text: "Method" },
                    { text: "Construction" },
                    { text: "Training" }]
            };
        case 12:
            return {
                question: "ART is to INSPIRATION as CONSTRUCTION is to:",
                responses: 1,
                answer: 5,
                options: [
                    { text: "Perspiration" },
                    { text: "Revelation" },
                    { text: "Encouragement" },
                    { text: "Motivation" },
                    { text: "Planning" }]
            };
        case 13:
            return {
                question: "KNOWLEDGE is to IGNORANCE as ORDER is to:",
                responses: 1,
                answer: 4,
                options: [
                    { text: "Suspicion" },
                    { text: "Ineptitude" },
                    { text: "Incompetence" },
                    { text: "Chaos" },
                    { text: "Stupidity" }]
            };
        case 14:
            return {
                question: "KILOMETRE is to DISTANCE as LITRE is to:",
                responses: 1,
                answer: 3,
                options: [
                    { text: "Curvilinear" },
                    { text: "Space" },
                    { text: "Volume" },
                    { text: "Measurement" },
                    { text: "Area" }]
            };
        case 15:
            return {
                question: "Find the word that means most nearly the SAME as TRADE.",
                responses: 1,
                answer: 4,
                options: [
                    { text: "Buy" },
                    { text: "Purchase" },
                    { text: "Acquire" },
                    { text: "Barter" },
                    { text: "Obtain" }]
            };
        case 16:
            return {
                question: "Find the word that means most nearly the SAME as BIGOTED.",
                responses: 1,
                answer: 5,
                options: [
                    { text: "Tolerant" },
                    { text: "Unfair" },
                    { text: "Cheat" },
                    { text: "Dishonest" },
                    { text: "Biased" }]
            };
        case 17:
            return {
                question: "Which TWO of the following words are OPPOSITE OR NEARLY OPPOSITE in meaning?",
                responses: 2,
                answer: 35,
                options: [
                    { text: "Obtuse" },
                    { text: "Oblivious" },
                    { text: "Subtle" },
                    { text: "Insensitive" },
                    { text: "Evident" }]
            };
        case 18:
            return {
                question: "Find the word that means nearly the SAME as ALLEVIATE.",
                responses: 1,
                answer: 2,
                options: [
                    { text: "Levitate" },
                    { text: "Assuage" },
                    { text: "Tighten" },
                    { text: "Chastise" },
                    { text: "Intuition" }]
            };
        case 19:
            return {
                question: "Which TWO of the following words are OPPOSITE OR NEARLY OPPOSITE in meaning?",
                responses: 2,
                answer: 14,
                options: [
                    { text: "Abstract" },
                    { text: "Extract" },
                    { text: "Summary" },
                    { text: "Concrete" },
                    { text: "Exact" }]
            };
        case 20:
            return {
                question: "Find the word that means nearly the SAME as INDIFFERENCE.",
                responses: 1,
                answer: 5,
                options: [
                    { text: "Agitated" },
                    { text: "Amiable" },
                    { text: "Empathetic" },
                    { text: "Confluence" },
                    { text: "Apathy" }]
            };
        case 21:
            return {
                question: "Which TWO of the following words are OPPOSITE OR NEARLY OPPOSITE in meaning?",
                responses: 2,
                answer: 45,
                options: [
                    { text: "Imminent" },
                    { text: "Strategy" },
                    { text: "Ambiguous" },
                    { text: "Obscure" },
                    { text: "Famous" }]
            };
        case 22:
            return {
                question: "Find the word that means nearly the SAME as RUSE.",
                responses: 1,
                answer: 3,
                options: [
                    { text: "Subtle" },
                    { text: "Contrary" },
                    { text: "Hoax" },
                    { text: "Conception" },
                    { text: "Approximate" }]
            };
        case 23:
            return {
                question: "Find the TWO statements which together prove that TRAINS TRAVEL FASTER THAN BICYCLES?",
                responses: 2,
                answer: 15,
                options: [
                    { text: "Trains travel faster than trucks." },
                    { text: "Trucks travel on roads." },
                    { text: "Some trucks travel very fast." },
                    { text: "Some trains have diesel engines." },
                    { text: "Trucks travel faster than bicycles." }]
            };
        case 24:
            return {
                question: "Find the TWO statements which together prove that I WROTE AN EMAIL YESTERDAY MORNING?",
                responses: 2,
                answer: 14,
                options: [
                    { text: "I always write my emails in the morning." },
                    { text: "I always send emails as soon as I write them." },
                    { text: "I did not write an email this morning." },
                    { text: "I wrote an email yesterday." },
                    { text: "I received an email yesterday." }]
            };
        case 25:
            return {
                question: "Find the TWO statements which together prove that BEN HAS FOUR SISTERS?",
                responses: 2,
                answer: 13,
                options: [
                    { text: "Mary has three sisters and two brothers." },
                    { text: "In total, Ben has 5 brothers or sisters." },
                    { text: "Ben has one more sister than Mary has." },
                    { text: "None of Ben's sisters are older than him." },
                    { text: "Ben has one younger brother." }]
            };
        case 26:
            return {
                question: "I have 5 coloured bolts (red, green, blue, yellow and brown). The green and brown bolts are metric while the others are imperial. The red and blue bolts are right-handed while the others are left-handed. The blue and yellow bolts are brass while the others are steel. Which bolt is imperial, right-handed and brass?",
                responses: 1,
                answer: 3,
                options: [
                    { text: "Red" },
                    { text: "Green" },
                    { text: "Blue" },
                    { text: "Yellow" },
                    { text: "Brown" }]
            };
        case 27:
            return {
                question: "Find the TWO statements which together prove that TONY HAS A BOAT.",
                responses: 2,
                answer: 24,
                options: [
                    { text: "All the employees at the site like fishing." },
                    { text: "Everyone at the site owns a boat." },
                    { text: "Tony likes fishing." },
                    { text: "Tony works at the site." },
                    { text: "The site is near a river." }]
            };
        case 28:
            return {
                question: "If Team A does not make the finals then Team B does make the finals. If Team B does not make the finals then either Team C or Team D make the finals. If Team B does make the finals then Team C makes the finals. If Team A does not make the finals which TWO of the following statements MUST be true?",
                responses: 2,
                answer: 12,
                options: [
                    { text: "Team B made the finals." },
                    { text: "Team C made the finals." },
                    { text: "Team D made the finals." },
                    { text: "Team B did not make the finals." },
                    { text: "Team C did not make the finals." }]
            };
        case 29:
            return {
                question: "Find the TWO statements which together prove that it HAS NOT RAINED IN THE REGION RECENTLY.",
                responses: 2,
                answer: 13,
                options: [
                    { text: "Algae does not grow in the river if it has rained recently." },
                    { text: "The region does not get rain very often." },
                    { text: "There is algae in the river." },
                    { text: "The river is flowing at only half its maximum depth." },
                    { text: "It is Summer now." }]
            };
        default:
            return null;
    }
}

function getWorkProfileQuestionnaireIntro() {
    return {
        elems: [
            { type: "h1", text: "WORK PROFILE QUESTIONNAIRE", icon: "far fa-ballot" },
            {
                type: "g", elems: [
                    { type: "p", text: "This test assesses various attitudes and beliefs about you and your work." },
                    { type: "p", text: "You will go through 84 different statements." },
                    { type: "p", text: "There's no time limit for this test." }]
            }]
    };
}

function getWorkProfileQuestionnaireInstructions() {
    return {
        disableNext: true,
        elems: [
            {
                type: "t",
                elems: [
                    {
                        type: "-",
                        tabId: 1,
                        elems: [
                            { type: "p", text: "Your task is to rate each statement in terms of how well it describes your typical behaviour or beliefs, or how much you agree or disagree with it." }]
                    },
                    {
                        type: "-",
                        tabId: 2,
                        elems: [
                            { type: "p", text: "It is best to respond honestly as the test is sensitive to inconsistency and exaggeration." }]
                    },
                    {
                        type: "-",
                        tabId: 3,
                        elems: [
                            { type: "p", text: "When you are ready, select your response to the statement below and click NEXT to proceed." }]
                    }]
            }],
        question: "I have read the instructions and I'm ready to complete this survey honestly"
    };
}

function getWorkProfileQuestionnaireContent(index) {
    switch (index) {
        case 0: return "I try to follow the rules";
        case 1: return "I like driving fast on open roads";
        case 2: return "I am concerned about others";
        case 3: return "I get the job done right first time, every time";
        case 4: return "I have more fears and worries than most people";
        case 5: return "I like to keep my tools in their set place";
        case 6: return "I feel sympathy for those who are worse off than myself";
        case 7: return "I make sure I assess the risks on any job before I start work";
        case 8: return "I enjoy setting goals and then going after them";
        case 9: return "I often feel helpless and want someone else to solve my problems";
        case 10: return "I sympathise with the homeless";
        case 11: return "I take a little extra time to make sure I’ve not made any mistakes in my work";
        case 12: return "I am stricter about safety procedures than most people I work with";
        case 13: return "I am likely to show off if I get the chance";
        case 14: return "I believe that the poor deserve our sympathy";
        case 15: return "I feel sleepy during the day";
        case 16: return "I enjoy the challenge of developing new and better ways to get the job done";
        case 17: return "I believe there is never an excuse for lying";
        case 18: return "I feel little concern for others";
        case 19: return "At work, I refuse to do things if I think they are not safe";
        case 20: return "Sometimes things look pretty bleak and hopeless to me";
        case 21: return "Others tell me I snore or gasp when I’m asleep";
        case 22: return "I have no sympathy for criminals";
        case 23: return "I let little things upset me more than they should";
        case 24: return "Each person is ultimately responsible for their own safety";
        case 25: return "I have little influence about how things are done at work, even though these things affect my safety";
        case 26: return "I believe that criminals should receive help rather than punishment";
        case 27: return "I prefer to pace myself and get the job done safely";
        case 28: return "I tend to blame myself when things go wrong";
        case 29: return "When I say I’ll do something, I do it";
        case 30: return "I don't like to get involved in other people's problems";
        case 31: return "I feel tired and find it hard to concentrate during the day";
        case 32: return "I would never take things that aren't mine";
        case 33: return "I think most of the injuries people have at work are because of bad luck";
        case 34: return "Getting the job done safely is more important than getting the job done quickly";
        case 35: return "I have little sympathy for the unemployed";
        case 36: return "I have sometimes had to tell a lie";
        case 37: return "It is sheer chance when someone gets hurt at work";
        case 38: return "I usually give some thought to how my actions will affect others";
        case 39: return "Success is based on survival of the fittest; I am not concerned about losers";
        case 40: return "I strive to achieve my goals";
        case 41: return "I hate leaving a job half done";
        case 42: return "When I make a commitment I follow through";
        case 43: return "For me, what’s right is whatever I can get away with";
        case 44: return "I think twice before I answer questions";
        case 45: return "I cheat to get ahead";
        case 46: return "I like to know what work is planned for the day";
        case 47: return "In today’s world, I feel justified in doing anything I can get away with to succeed";
        case 48: return "I tell the truth";
        case 49: return "I wake up with muscle soreness";
        case 50: return "I use flattery to get ahead";
        case 51: return "My main purpose in life is getting as many goodies as I can";
        case 52: return "I make a point of being on time for appointments";
        case 53: return "If I’m safe at work it’s because I make sure of it";
        case 54: return "I would never cheat on my taxes";
        case 55: return "Making a lot of money is my most important goal";
        case 56: return "I find myself falling asleep at odd times";
        case 57: return "I feel tense and worried fairly often";
        case 58: return "I get bored easily";
        case 59: return "I let others worry about higher values; my main concern is with the bottom line";
        case 60: return "I am not always what I appear to be";
        case 61: return "I take a long time to fall asleep";
        case 62: return "Staying safe at work has almost nothing to do with luck, it’s about how I think and act";
        case 63: return "I believe that people who are stupid enough to get ripped off usually deserve it";
        case 64: return "I hate finding out I’ve made a mistake in my work";
        case 65: return "I get annoyed when I see strong people ripping off weaker people";
        case 66: return "I wake up after only a short period of sleep and find difficulty in going back to sleep";
        case 67: return "Looking out for myself is my top priority";
        case 68: return "I break rules";
        case 69: return "I seem to spend a lot of time looking for things I’ve misplaced";
        case 70: return "I strive to be the best at what I do";
        case 71: return "I can’t do anything to change procedures at my place of work";
        case 72: return "I often admire a really clever scam";
        case 73: return "Other people see me as a very disciplined person";
        case 74: return "I keep a cool head, even in a crisis";
        case 75: return "I wake up feeling tired";
        case 76: return "I would be upset if my success came at someone else’s expense";
        case 77: return "I buy things and then regret spending the money later";
        case 78: return "I set higher standards for myself than most people";
        case 79: return "I misuse power";
        case 80: return "I follow through with my plans";
        case 81: return "It doesn’t matter how careful I am, if I am going to get hurt, I will";
        case 82: return "I don't always practice what I preach";
        default:
            return null;
    }
}

function getPersonalFactorsInventoryIntro() {
    return {
        elems: [
            { type: "h1", text: "PERSONAL FACTORS INVENTORY", icon: "far fa-ballot" },
            {
                type: "g", elems: [
                    { type: "p", text: "This test measures attitudes and behaviours." },
                    { type: "p", text: "There are no right or wrong answers, as your responses are simply descriptive of your preferences." },
                    { type: "p", text: "This time you will go through 163 statements. There's no time limit for this test." }]
            }]
    };
}

function getPersonalFactorsInventoryInstructions() {
    return {
        disableNext: true,
        elems: [
            {
                type: "t",
                elems: [
                    {
                        type: "-",
                        tabId: 1,
                        elems: [
                            { type: "p", text: "Your task is to use this rating scale to indicate how accurately each statement describes you." }]
                    },
                    {
                        type: "-",
                        tabId: 2,
                        elems: [
                            { type: "p", text: "It is best to respond honestly, describe yourself as you have been in recent months." }]
                    },
                    {
                        type: "-",
                        tabId: 3,
                        elems: [
                            { type: "p", text: "When you are ready, select your response to the statement below and click NEXT to proceed." }]
                    }]
            }],
        question: "I have read the instructions and I'm ready to complete this survey honestly"
    };
}

function getPersonalFactorsInventoryContent(index) {
    switch (index) {
        case 0: return "like to stand during the national anthem";
        case 1: return "am not bothered by disorder";
        case 2: return "believe in the importance of art";
        case 3: return "leave my belongings around";
        case 4: return "have a poor vocabulary";
        case 5: return "believe that others have good intentions";
        case 6: return "swim against the current";
        case 7: return "carry the conversation to a higher level";
        case 8: return "enjoy being part of a group";
        case 9: return "feel comfortable around people";
        case 10: return "continue until everything is perfect";
        case 11: return "want to be in charge";
        case 12: return "counter others' arguments";
        case 13: return "believe in one true religion";
        case 14: return "believe that people are basically moral";
        case 15: return "don't mind eating alone";
        case 16: return "get angry easily";
        case 17: return "keep in the background";
        case 18: return "am the life of the party";
        case 19: return "love flowers";
        case 20: return "reveal little about myself";
        case 21: return "have little to say";
        case 22: return "don't let others discourage me";
        case 23: return "tend to analyse things";
        case 24: return "seldom get lost in thought";
        case 25: return "distrust people";
        case 26: return "feel others' emotions";
        case 27: return "find it hard to forgive others";
        case 28: return "can't do without the company of others";
        case 29: return "don't like to get involved in other people's problems";
        case 30: return "joke around a lot";
        case 31: return "am easily hurt";
        case 32: return "am not interested in abstract ideas";
        case 33: return "amuse my friends";
        case 34: return "prefer to do things by myself";
        case 35: return "am open about my feelings";
        case 36: return "am relaxed most of the time";
        case 37: return "talk to a lot of different people at parties";
        case 38: return "reflect on things before acting";
        case 39: return "am not afraid of providing criticism";
        case 40: return "enjoy discussing movies and books with others";
        case 41: return "spend time thinking about past mistakes";
        case 42: return "worry about things";
        case 43: return "want everything to be 'just right'";
        case 44: return "feel comfortable with myself";
        case 45: return "am not easily bothered by things";
        case 46: return "am not easily annoyed";
        case 47: return "act wild and crazy";
        case 48: return "am quick to judge others";
        case 49: return "try to follow the rules";
        case 50: return "seldom joke around";
        case 51: return "try to avoid complex people";
        case 52: return "enjoy spending time by myself";
        case 53: return "judge people by their appearance";
        case 54: return "consider myself an average person";
        case 55: return "enjoy teamwork";
        case 56: return "weigh the pros against the cons";
        case 57: return "rarely notice my emotional reactions";
        case 58: return "enjoy my privacy";
        case 59: return "make friends easily";
        case 60: return "am not interested in theoretical discussions";
        case 61: return "am not bothered by messy people";
        case 62: return "seldom daydream";
        case 63: return "try to forgive and forget";
        case 64: return "know how to get around the rules";
        case 65: return "want to be left alone";
        case 66: return "use swear words";
        case 67: return "feel threatened easily";
        case 68: return "can take strong measures";
        case 69: return "like to get lost in thought";
        case 70: return "enjoy silence";
        case 71: return "know that I am not a special person";
        case 72: return "read a lot";
        case 73: return "am wary of others";
        case 74: return "oppose authority";
        case 75: return "am annoyed by others' mistakes";
        case 76: return "keep my thoughts to myself";
        case 77: return "have a good word for everyone";
        case 78: return "dislike works of fiction";
        case 79: return "know the answers to many questions";
        case 80: return "rarely look for a deeper meaning in things";
        case 81: return "do not like poetry";
        case 82: return "don't talk a lot";
        case 83: return "do things that others find strange";
        case 84: return "suspect hidden motives in others";
        case 85: return "put off unpleasant tasks";
        case 86: return "make people feel at ease";
        case 87: return "do not enjoy watching dance performances";
        case 88: return "try not to think about the needy";
        case 89: return "am willing to talk about myself";
        case 90: return "am hard to get to know";
        case 91: return "love large parties";
        case 92: return "get confused easily";
        case 93: return "love to think up new ways of doing things";
        case 94: return "start conversations";
        case 95: return "say what I think";
        case 96: return "am open about myself to others";
        case 97: return "cry during movies";
        case 98: return "use my brain";
        case 99: return "feel desperate";
        case 100: return "bottle up my feelings";
        case 101: return "can't stand being contradicted";
        case 102: return "disclose my intimate thoughts";
        case 103: return "respect authority";
        case 104: return "have frequent mood swings";
        case 105: return "readily overcome setbacks";
        case 106: return "am not really interested in others";
        case 107: return "believe laws should be strictly enforced";
        case 108: return "skip difficult words while reading";
        case 109: return "don't mind being the centre of attention";
        case 110: return "take charge";
        case 111: return "am easily put out";
        case 112: return "feel guilty when I say no";
        case 113: return "am quiet around strangers";
        case 114: return "get chores done right away";
        case 115: return "prefer variety to routine";
        case 116: return "dislike loud music";
        case 117: return "seldom feel blue";
        case 118: return "love to daydream";
        case 119: return "believe that people seldom tell you the whole story";
        case 120: return "get irritated easily";
        case 121: return "know how to comfort others";
        case 122: return "leave a mess in my room";
        case 123: return "enjoy wild flights of fantasy";
        case 124: return "cheer people up";
        case 125: return "let others make the decisions";
        case 126: return "do unexpected things";
        case 127: return "like order";
        case 128: return "am the last to laugh at a joke";
        case 129: return "am afraid that I will do the wrong thing";
        case 130: return "take control of things";
        case 131: return "do things by the book";
        case 132: return "show my feelings";
        case 133: return "often feel blue";
        case 134: return "often feel uncomfortable around others";
        case 135: return "feel crushed by setbacks";
        case 136: return "trust others";
        case 137: return "resist authority";
        case 138: return "take an interest in other people's lives";
        case 139: return "dislike myself";
        case 140: return "am exacting in my work";
        case 141: return "break rules";
        case 142: return "am easily discouraged";
        case 143: return "trust what people say";
        case 144: return "find it difficult to approach others";
        case 145: return "avoid philosophical discussions";
        case 146: return "don't like crowded events";
        case 147: return "take time out for others";
        case 148: return "enjoy hearing new ideas";
        case 149: return "seek quiet";
        case 150: return "wait for others to lead the way";
        case 151: return "learn quickly";
        case 152: return "let myself be pushed around";
        case 153: return "am not easily frustrated";
        case 154: return "don't worry about things that have already happened";
        case 155: return "believe that people are essentially evil";
        case 156: return "like to read";
        case 157: return "enjoy bringing people together";
        case 158: return "enjoy being part of a loud crowd";
        case 159: return "make insightful remarks";
        case 160: return "never challenge things";
        case 161: return "don't like action movies";
        case 162: return "take deviant positions";
        default:
            return null;
    }
}
